import { Routes } from '@angular/router'
import { AppComponent } from './app/khb.component';
import { DashboardComponent } from './app/dashboard/dashboard.component';
import { RegistrationComponent } from './app/registration/registration.component';
import { LoginComponent } from './app/registration/login/login.component';
import { SignupComponent } from './app/registration/signup/signup.component';
import { AllocationComponent } from './app/allocation/allocation.component';
import { ApplicationformComponent } from './app/allocation/forms/applicationform/applicationform.component';
import { UltilitiesComponent } from './app/ultilities/ultilities.component';
import { RolesComponent } from './app/ultilities/roles/roles.component';
import { RolesGridComponent } from './app/ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './app/ultilities/roles/roles-form/roles-form.component';
import { UserComponent } from './app/ultilities/user/user.component';
import { UserGridComponent } from './app/ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './app/ultilities/user/user-form/user-form.component';
import { ClaimsComponent } from './app/ultilities/claims/claims/claims.component';
import { ClaimGridComponent } from './app/ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './app/ultilities/claims/claims/claim-form/claim-form.component';
import { SettingComponent } from './app/ultilities/setting/setting.component';
import { MasterComponent } from './app/master/master.component';
import { OfficeGridComponent } from './app/master/office/office-grid/office-grid.component';
import { OfficeComponent } from './app/master/office/office.component';
import { OfficeFormComponent } from './app/master/office/office-form/office-form.component';
import { HomepageComponent } from './app/homepage/homepage.component';
import { AuthGuard } from './app/auth/auth.guard';
import { ChangePasswordComponent } from './app/ultilities/change-password/change-password.component';
import { GridComponent } from './app/allocation/khbnotification/grid/grid.component';
import { FormComponent } from './app/allocation/khbnotification/form/form.component';
import { PrAllotmentGridComponent } from './app/allocation/pr-allotment/pr-allotment-grid/pr-allotment-grid.component';
import { PrAllotmentFormComponent } from './app/allocation/pr-allotment/pr-allotment-form/pr-allotment-form.component';
import { PrAllotmentNotsentComponent } from './app/allocation/pr-allotment/pr-allotment-notsent/pr-allotment-notsent.component';
import { PropertyregisterGridComponent } from './app/allocation/property-register/propertyregister-grid/propertyregister-grid.component';
import { PropertyregisterFormComponent } from './app/allocation/property-register/propertyregister-form/propertyregister-form.component';
import { SmsGridComponent } from './app/allocation/smsby-location/sms-grid/sms-grid.component';
import { SmsFormComponent } from './app/allocation/smsby-location/sms-form/sms-form.component';
import { CampaignDetailsComponent } from './app/allocation/smsby-location/campaign-details/campaign-details.component';
import { WebsitenewsGridComponent } from './app/allocation/website-news/websitenews-grid/websitenews-grid.component';
import { WebsitenewsFormComponent } from './app/allocation/website-news/websitenews-form/websitenews-form.component';
import { ApplicantComponent } from './app/applicant/applicant.component';
import { ProfileComponent } from './app/applicant/profile/profile.component';
import { ActivelistComponent } from './app/applicant/apply/activelist/activelist.component';
import { ApplicationstatusComponent } from './app/applicant/applicationstatus/applicationstatus.component';
import { ApplicationViewComponent } from './app/applicant/application-view/application-view.component';
import { PaymentComponent } from './app/applicant/payment/payment.component';
import { ScrutinyComponent } from './app/allocation/scrutiny/scrutiny.component';
import { LotteryComponent } from './app/allocation/lottery/lottery.component';
import { AllottmentListComponent } from './app/allocation/allottment-list/allottment-list.component';
import { NotAllotedListComponent } from './app/allocation/not-alloted-list/not-alloted-list.component';
import { InstallmentconfigComponent } from './app/allocation/installmentconfig/installmentconfig.component';
import { AllotmentCancellationComponent } from './app/allocation/allotment-cancellation/allotment-cancellation.component';
import { ForgotPasswordComponent } from './app/registration/forgot-password/forgot-password.component';
import { FinanceComponent } from './app/finance/finance.component';
import { PaymentConfigComponent } from './app/finance/payment-config/payment-config.component';
import { RefundComponent } from './app/finance/refund/refund.component';
import { ChangeAddressComponent } from './app/applicant/change-address/change-address.component';
import { RefundRequestComponent } from './app/applicant/refund-request/refund-request.component';
import { NotAllotedRefundComponent } from './app/allocation/not-alloted-refund/not-alloted-refund.component';
import { RefundlistComponent } from './app/finance/refundlist/refundlist.component';
import { ProjectMasterComponent } from './app/master/project-master/project-master.component';
import { ReAllotmentComponent } from './app/allocation/re-allotment/re-allotment.component';
import { PrintAllotmentletterComponent } from './app/allocation/print-allotmentletter/print-allotmentletter.component';
import { ChangePropertyComponent } from './app/allocation/change-property/change-property.component';
import { WaitingListComponent } from './app/allocation/waiting-list/waiting-list.component';
import { DefaultersComponent } from './app/allocation/defaulters/defaulters.component';
import { SaledeedComponent } from './app/allocation/saledeed/saledeed.component';
import { EKhataComponent } from './app/allocation/e-khata/e-khata.component';
import { ProjectmasterFormComponent } from './app/master/project-master/projectmaster-form/projectmaster-form.component';
import { ProjectmasterGridComponent } from './app/master/project-master/projectmaster-grid/projectmaster-grid.component';
import { ChangePropertygridComponent } from './app/allocation/change-property/change-propertygrid/change-propertygrid.component';
import { ChangePropertyformComponent } from './app/allocation/change-property/change-propertyform/change-propertyform.component';
import { InstallmentDueComponent } from './app/allocation/installment-due/installment-due.component';
import { ProvisionAllotmentComponent } from './app/allocation/provision-allotment/provision-allotment.component';
import { MaintainanceFeeComponent } from './app/allocation/maintainance-fee/maintainance-fee.component';
import { PlanningComponent } from './app/planning/planning.component';
import { ProjectListComponent } from './app/planning/project/project-list/project-list.component';

import { LandrecordlistComponent } from './app/planning/land-record/landrecordlist/landrecordlist.component';
import { LandrecordformComponent } from './app/planning/land-record/landrecordform/landrecordform.component';
import { ValidatelandrecordlistComponent } from './app/planning/validatelandrecordlist/validatelandrecordlist.component';


import { ProjectFormComponent } from './app/planning/project/project-form/project-form.component';
import { PropertyPlanAlllistComponent } from './app/allocation/pr-allotment/property-plan-alllist/property-plan-alllist.component';
import { ConsultantFromComponent } from './app/planning/consultant/consultant-from/consultant-from.component';
import { StatutoryClearancesFormComponent } from './app/planning/statutory-clearances/statutory-clearances-form/statutory-clearances-form.component';
import { KhbDrawingFormComponent } from './app/planning/khb-drawing/khb-drawing-form/khb-drawing-form.component';
import { ApprovedDrawingFormComponent } from './app/planning/approved-drawing/approved-drawing-form/approved-drawing-form.component';
import { BuiltDrawingFormComponent } from './app/planning/built-drawing/built-drawing-form/built-drawing-form.component';
import { RevisedDrawingFormComponent } from './app/planning/revised-drawing/revised-drawing-form/revised-drawing-form.component';
import { ApprovedDrawingGridComponent } from './app/planning/approved-drawing/approved-drawing-grid/approved-drawing-grid.component';
import { StatutoryClearancesGridComponent } from './app/planning/statutory-clearances/statutory-clearances-grid/statutory-clearances-grid.component';
import { KhbDrawingGridComponent } from './app/planning/khb-drawing/khb-drawing-grid/khb-drawing-grid.component';
import { BuiltDrawingGridComponent } from './app/planning/built-drawing/built-drawing-grid/built-drawing-grid.component';
import { RevisedDrawingGridComponent } from './app/planning/revised-drawing/revised-drawing-grid/revised-drawing-grid.component';
import { AllotmentProjectListComponent } from './app/allocation/allotment-cancellation/allotment-project-list/allotment-project-list.component';
import { ProjectNamesComponent } from './app/allocation/allotment-cancellation/project-names/project-names.component';
import { AllotmentAllottedPropertyComponent } from './app/allocation/allotment-cancellation/allotment-allotted-property/allotment-allotted-property.component';
import { PaymentDetailsComponent } from './app/allocation/allotment-cancellation/payment-details/payment-details.component';
import { SaledeedDetailsComponent } from './app/allocation/allotment-cancellation/saledeed-details/saledeed-details.component';
import { CancelAllotmentComponent } from './app/allocation/allotment-cancellation/cancel-allotment/cancel-allotment.component';
import { SoldpropertyComponent } from './app/allocation/saledeed/soldproperty/soldproperty.component';
import { SaleComponent } from './app/allocation/saledeed/sale/sale.component';
import { PropertiesregisterListComponent } from './app/planning/propertiesregister/propertiesregister-list/propertiesregister-list.component';
import { PropertiesregisterFormComponent } from './app/planning/propertiesregister/propertiesregister-form/propertiesregister-form.component';
import { ConsultantListComponent } from './app/planning/consultant/consultant-list/consultant-list.component';
import { ScrutinyViewComponent } from './app/allocation/scrutiny-view/scrutiny-view.component';
import { ProvisionlistComponent } from './app/allocation/provisionlist/provisionlist.component';
import { FinalListComponent } from './app/allocation/final-list/final-list.component';
import { RevisedpropertyregisterGridComponent } from './app/planning/revisedpropertyregister/revisedpropertyregister-grid/revisedpropertyregister-grid.component';
import { RevisedpropertyregisterFormComponent } from './app/planning/revisedpropertyregister/revisedpropertyregister-form/revisedpropertyregister-form.component';
import { ApplicationlistComponent } from './app/allocation/applicationlist/applicationlist.component';
import { KhbnotificationComponent } from './app/pdf-forms/khbnotification/khbnotification.component';
import { LandprocurementComponent } from './app/landprocurement/landprocurement.component';
import { ProposalGridComponent } from './app/landprocurement/proposal-report/proposal-grid/proposal-grid.component';
import { ProposalFormComponent } from './app/landprocurement/proposal-report/proposal-form/proposal-form.component';
import { ViabilityGridComponent } from './app/landprocurement/viability-report/viability-grid/viability-grid.component';
import { ViabilityFormComponent } from './app/landprocurement/viability-report/viability-form/viability-form.component';
import { InspectionGridComponent } from './app/landprocurement/inspection-report/inspection-grid/inspection-grid.component';
import { InspectionFormComponent } from './app/landprocurement/inspection-report/inspection-form/inspection-form.component';
import { OnGridComponent } from './app/landprocurement/objectionnotification/on-grid/on-grid.component';
import { OnFormComponent } from './app/landprocurement/objectionnotification/on-form/on-form.component';
import { RateGridComponent } from './app/landprocurement/rate-fixation/rate-grid/rate-grid.component';
import { RateFormComponent } from './app/landprocurement/rate-fixation/rate-form/rate-form.component';
import { LanddetailsGridComponent } from './app/landprocurement/land-details/landdetails-grid/landdetails-grid.component';
import { LanddetailsFormComponent } from './app/landprocurement/land-details/landdetails-form/landdetails-form.component';
import { LandpaymentGridComponent } from './app/landprocurement/land-payment/landpayment-grid/landpayment-grid.component';
import { LandpaymentFormComponent } from './app/landprocurement/land-payment/landpayment-form/landpayment-form.component';
import { LegalComponent } from './app/legal/legal.component';
import { CrViewComponent } from './app/legal/case-registration/cr-view/cr-view.component';
import { CrFormComponent } from './app/legal/case-registration/cr-form/cr-form.component';
import { CpViewComponent } from './app/legal/case-proceeding/cp-view/cp-view.component';
import { CpFormComponent } from './app/legal/case-proceeding/cp-form/cp-form.component';
import { DistrictViewComponent } from './app/master/district/district-view/district-view.component';
import { DistrictFormComponent } from './app/master/district/district-form/district-form.component';
import { CourtViewComponent } from './app/master/court/court-view/court-view.component';
import { CourtFormComponent } from './app/master/court/court-form/court-form.component';
import { CourttypeViewComponent } from './app/master/court-type/courttype-view/courttype-view.component';
import { CourttypeFormComponent } from './app/master/court-type/courttype-form/courttype-form.component';
//import { AdvocatesViewComponent } from './app/master/advocates/advocates-view/advocates-view.component';
//import { AdvocatesFormComponent } from './app/master/advocates/advocates-form/advocates-form.component';
import { DeptViewComponent } from './app/master/department/dept-view/dept-view.component';
import { DeptFormComponent } from './app/master/department/dept-form/dept-form.component';
import { LandrecGridComponent } from './app/landprocurement/land-rec-details/landrec-grid/landrec-grid.component';
import { LandrecFormComponent } from './app/landprocurement/land-rec-details/landrec-form/landrec-form.component';
import { ELotteryComponent } from './app/allocation/e-lottery/e-lottery.component';
import { ManualGridComponent } from './app/allocation/manual-lottery/manual-grid/manual-grid.component';
import { ManualFormComponent } from './app/allocation/manual-lottery/manual-form/manual-form.component';
import { PaymentConfigViewComponent } from './app/finance/payment-config-view/payment-config-view.component';
import { UserApplicationComponent } from './app/applicant/user-application/user-application.component';
import { ApplicantApplicationComponent } from './app/applicant/user-application/applicant-application/applicant-application.component';
import { ApplicantApplicationFormComponent } from './app/applicant/user-application/applicant-application-form/applicant-application-form.component';
import { khbChallanComponent } from './app/pdf-forms/khb-challan/khb-challan.component';
import { StatusviewComponent } from './app/applicant/status/statusview/statusview.component';
import { ApplicationinstallmentpayComponent } from './app/applicant/applicationinstallmentpay/applicationinstallmentpay.component';
import { ApplicationcancellationComponent } from './app/applicant/applicationcancellation/applicationcancellation.component';
import { ApplicationrefundComponent } from './app/applicant/applicationrefund/applicationrefund.component';
import { TransactionDetailsComponent } from './app/applicant/transaction-details/transaction-details.component';
import { AppstatusComponent } from './app/applicant/appstatus/appstatus.component';
import { TechnicalComponent } from './app/technical/technical.component';
import { DesignIssueGridComponent } from './app/technical/project-design-issue/design-issue-grid/design-issue-grid.component';
import { DesignIssueFormComponent } from './app/technical/project-design-issue/design-issue-form/design-issue-form.component';
import { QuantumGridComponent } from './app/technical/encumbrances-quantum/quantum-grid/quantum-grid.component';
import { QuantumFormComponent } from './app/technical/encumbrances-quantum/quantum-form/quantum-form.component';
import { DocTypeGridComponent } from './app/technical/contractor-doc-type/doc-type-grid/doc-type-grid.component';
import { DocTypeFormComponent } from './app/technical/contractor-doc-type/doc-type-form/doc-type-form.component';
import { ContractordocGridComponent } from './app/technical/contractor-documents/contractordoc-grid/contractordoc-grid.component';
import { ContractordocFormComponent } from './app/technical/contractor-documents/contractordoc-form/contractordoc-form.component';
import { ContractorFormComponent } from './app/technical/contractor/contractor-form/contractor-form.component';
import { ContractorGridComponent } from './app/technical/contractor/contractor-grid/contractor-grid.component';
import { MilestoneFormComponent } from './app/technical/milestones/milestone-form/milestone-form.component';
import { MilestoneGridComponent } from './app/technical/milestones/milestone-grid/milestone-grid.component';
import { BoqitemFormComponent } from './app/technical/boq-item/boqitem-form/boqitem-form.component';
import { BoqitemGridComponent } from './app/technical/boq-item/boqitem-grid/boqitem-grid.component';
import { JobsFormComponent } from './app/technical/jobs/jobs-form/jobs-form.component';
import { JobsViewComponent } from './app/technical/jobs/jobs-view/jobs-view.component';
import { JobgroupViewComponent } from './app/technical/jobgroup/jobgroup-view/jobgroup-view.component';
import { JobgroupFormComponent } from './app/technical/jobgroup/jobgroup-form/jobgroup-form.component';
import { ActivityGridComponent } from './app/technical/project-activity/activity-grid/activity-grid.component';
import { ActivityFormComponent } from './app/technical/project-activity/activity-form/activity-form.component';
import { BoqFormComponent } from './app/technical/basline-boq/boq-form/boq-form.component';
import { BoqGridComponent } from './app/technical/basline-boq/boq-grid/boq-grid.component';
import { EquipmentFormComponent } from './app/technical/equipment/equipment-form/equipment-form.component';
import { EquipmentGridComponent } from './app/technical/equipment/equipment-grid/equipment-grid.component';
import { PescFormComponent } from './app/technical/pe-sc/pesc-form/pesc-form.component';
import { PescGridComponent } from './app/technical/pe-sc/pesc-grid/pesc-grid.component';
import { PescTypeFormComponent } from './app/technical/pe-sc-type/pesc-type-form/pesc-type-form.component';
import { PescTypeGridComponent } from './app/technical/pe-sc-type/pesc-type-grid/pesc-type-grid.component';
import { CasetypeGridComponent } from './app/master/casetype/casetype-grid/casetype-grid.component';
import { CasetypeFormComponent } from './app/master/casetype/casetype-form/casetype-form.component';
import { FilemasterFormComponent } from './app/master/file-master/filemaster-form/filemaster-form.component';
import { FilemasterGridComponent } from './app/master/file-master/filemaster-grid/filemaster-grid.component';
import { EncumbrancesGridComponent } from './app/technical/project-encumbrances/encumbrances-grid/encumbrances-grid.component';
import { EncumbrancesFormComponent } from './app/technical/project-encumbrances/encumbrances-form/encumbrances-form.component';
import { EncumbrancesTypeFormComponent } from './app/technical/project-encumbrances-type/encumbrances-type-form/encumbrances-type-form.component';
import { EncumbrancesTypeGridComponent } from './app/technical/project-encumbrances-type/encumbrances-type-grid/encumbrances-type-grid.component';
import { QcFormComponent } from './app/technical/qc/qc-form/qc-form.component';
import { QcGridComponent } from './app/technical/qc/qc-grid/qc-grid.component';
import { QcTypeFormComponent } from './app/technical/qc-type/qc-type-form/qc-type-form.component';
import { QcTypeGridComponent } from './app/technical/qc-type/qc-type-grid/qc-type-grid.component';
import { ProjectProgressFormComponent } from './app/technical/project-progress/project-progress-form/project-progress-form.component';
import { ProjectProgressGridComponent } from './app/technical/project-progress/project-progress-grid/project-progress-grid.component';
import { ScheduleExtensionFormComponent } from './app/technical/schedule-extension/schedule-extension-form/schedule-extension-form.component';
import { ScheduleExtensionGridComponent } from './app/technical/schedule-extension/schedule-extension-grid/schedule-extension-grid.component';
import { DesignIssueTypeGridComponent } from './app/technical/project-design-issue-type/design-issue-type-grid/design-issue-type-grid.component';
import { DesignIssueTypeFormComponent } from './app/technical/project-design-issue-type/design-issue-type-form/design-issue-type-form.component';
import { PhasescheduleFormComponent } from './app/technical/schedule/phaseschedule-form/phaseschedule-form.component';
import { PhasescheduleGridComponent } from './app/technical/schedule/phaseschedule-grid/phaseschedule-grid.component';
import { StructuresplanningFormComponent } from './app/technical/structures-planning/structuresplanning-form/structuresplanning-form.component';
import { StructuresplanningGridComponent } from './app/technical/structures-planning/structuresplanning-grid/structuresplanning-grid.component';
import { StructuresFormComponent } from './app/technical/structures/structures-form/structures-form.component';
import { StructuresViewComponent } from './app/technical/structures/structures-view/structures-view.component';
import { StaffFormComponent } from './app/technical/staff/staff-form/staff-form.component';
import { StaffGridComponent } from './app/technical/staff/staff-grid/staff-grid.component';
import { TenderFormComponent } from './app/technical/tender/tender-form/tender-form.component';
import { TenderGridComponent } from './app/technical/tender/tender-grid/tender-grid.component';
import { QueryComponent } from './app/legal/query/query.component';
import { FmFormComponent } from './app/legal/file-movement/fm-form/fm-form.component';
import { FmGridComponent } from './app/legal/file-movement/fm-grid/fm-grid.component';
import { CavFormComponent } from './app/legal/change-advocate/cav-form/cav-form.component';
import { CavGridComponent } from './app/legal/change-advocate/cav-grid/cav-grid.component';
import { AdvPayFormComponent } from './app/legal/advocate-payment/adv-pay-form/adv-pay-form.component';
import { AdvPayGridComponent } from './app/legal/advocate-payment/adv-pay-grid/adv-pay-grid.component';
import { AdvocatesGridComponent } from './app/legal/advocates/advocates-grid/advocates-grid.component';
import { LandpurchaseGridComponent } from './app/landprocurement/land-purchase/landpurchase-grid/landpurchase-grid.component';
import { LandpurchaseFormComponent } from './app/landprocurement/land-purchase/landpurchase-form/landpurchase-form.component';
import { LandacquisitionGridComponent } from './app/landprocurement/land-acquisition/landacquisition-grid/landacquisition-grid.component';
import { LandacquisitionFormComponent } from './app/landprocurement/land-acquisition/landacquisition-form/landacquisition-form.component';
import { auctionintimationComponent } from './app/pdf-forms/auctionintimation/auctionintimation.component';
import { auctionnotificationComponent } from './app/pdf-forms/auctionnotification/auctionnotification.component';
import { NotAllotedRefundFormComponent } from './app/allocation/not-alloted-refund-form/not-alloted-refund-form.component';
import { KhbInstachallanComponent } from './app/pdf-forms/khb-instachallan/khb-instachallan.component';

//HRMS Imports start
import { LeavesFormComponent } from './app/master/leaves/leaves-form/leaves-form.component';
import { LeavesGridComponent } from './app/master/leaves/leaves-grid/leaves-grid.component';
import { HolidaycalendarFormComponent } from './app/master/holidaycalendar/holidaycalendar-form/holidaycalendar-form.component';
import { HolidaycalendarGridComponent } from './app/master/holidaycalendar/holidaycalendar-grid/holidaycalendar-grid.component';
import { UserprofileFormComponent } from './app/master/userprofile/userprofile-form/userprofile-form.component';
import { UserprofileGridComponent } from './app/master/userprofile/userprofile-grid/userprofile-grid.component';
import { SalaryFormComponent } from './app/master/salary/salary-form/salary-form.component';
import { SalaryGridComponent } from './app/master/salary/salary-grid/salary-grid.component';
import { ScalesFormComponent } from './app/master/scales/scales-form/scales-form.component';
import { ScalesGridComponent } from './app/master/scales/scales-grid/scales-grid.component';
import { ReligionGridComponent } from './app/master/religion/religion-grid/religion-grid.component';
import { DesignationGridComponent } from './app/master/designations/designation-grid/designation-grid.component';
import { CasteFormComponent } from './app/master/caste/caste-form/caste-form.component';
import { CasteGridComponent } from './app/master/caste/caste-grid/caste-grid.component';
import { ReligionFormComponent } from './app/master/religion/religion-form/religion-form.component';
import { DesignationFormComponent } from './app/master/designations/designation-form/designation-form.component';

import { TransferOutGridComponent } from './app/hrms/transfer/transfer-out/transfer-out-grid/transfer-out-grid.component';
import { TransferInFormComponent } from './app/hrms/transfer/transfer-in/transfer-in-form/transfer-in-form.component';
import { TransferInGridComponent } from './app/hrms/transfer/transfer-in/transfer-in-grid/transfer-in-grid.component';
import { TransferComponent } from './app/hrms/transfer/transfer.component';
import { InsuranceDetailsFormComponent } from './app/hrms/payroll/insurance-details/insurance-details-form/insurance-details-form.component';
import { AttendanceDetailsFormComponent } from './app/hrms/payroll/attendance-details/attendance-details-form/attendance-details-form.component';
import { AttendanceDetailsGridComponent } from './app/hrms/payroll/attendance-details/attendance-details-grid/attendance-details-grid.component';
import { AllowancesDetailsFormComponent } from './app/hrms/payroll/allowances-details/allowances-details-form/allowances-details-form.component';
import { AllowancesDetailsGridComponent } from './app/hrms/payroll/allowances-details/allowances-details-grid/allowances-details-grid.component';
import { PayrollComponent } from './app/hrms/payroll/payroll.component';
import { BankDetailsFormComponent } from './app/hrms/serviceregister/bank-details/bank-details-form/bank-details-form.component';
import { BankDetailsGridComponent } from './app/hrms/serviceregister/bank-details/bank-details-grid/bank-details-grid.component';
import { LeaveDetailsGridComponent } from './app/hrms/serviceregister/leave-details/leave-details-grid/leave-details-grid.component';
import { QualificationInputGridComponent } from './app/hrms/serviceregister/qualification-input/qualification-input-grid/qualification-input-grid.component';
import { DependentGridComponent } from './app/hrms/serviceregister/dependent-details/dependent-grid/dependent-grid.component';
import { HrmsComponent } from './app/hrms/hrms.component';
import { TransferOutFormComponent } from './app/hrms/transfer/transfer-out/transfer-out-form/transfer-out-form.component';
import { DeductionDetailsGridComponent } from './app/hrms/payroll/deduction-details/deduction-details-grid/deduction-details-grid.component';
import { DeductionDetailsFormComponent } from './app/hrms/payroll/deduction-details/deduction-details-form/deduction-details-form.component';
import { InsuranceDetailsGridComponent } from './app/hrms/payroll/insurance-details/insurance-details-grid/insurance-details-grid.component';
import { EmpBasicDetailFormComponent } from './app/hrms/serviceregister/employee-basic-details/emp-basic-detail-form/emp-basic-detail-form.component';
import { DependentFormComponent } from './app/hrms/serviceregister/dependent-details/dependent-form/dependent-form.component';
import { QualificationInputFormComponent } from './app/hrms/serviceregister/qualification-input/qualification-input-form/qualification-input-form.component';
import { LeaveDetailsFormComponent } from './app/hrms/serviceregister/leave-details/leave-details-form/leave-details-form.component';
import { ServiceregisterComponent } from './app/hrms/serviceregister/serviceregister.component';
import { EmpBasicDetailGridComponent } from './app/hrms/serviceregister/employee-basic-details/emp-basic-detail-grid/emp-basic-detail-grid.component';
//HRMS Imports end

//Land Procurement Imports starts
import { RegisterdocGridComponent } from './app/landprocurement/registereddoc/registerdoc-grid/registerdoc-grid.component';
import { RegisterdocFormComponent } from './app/landprocurement/registereddoc/registerdoc-form/registerdoc-form.component';
import { ApprovalGridComponent } from './app/landprocurement/approval/approval-grid/approval-grid.component';
import { ApprovalFormComponent } from './app/landprocurement/approval/approval-form/approval-form.component';
import { DemandsurveyGridComponent } from './app/landprocurement/demand-survey/demandsurvey-grid/demandsurvey-grid.component';
import { DemandsurveyFormComponent } from './app/landprocurement/demand-survey/demandsurvey-form/demandsurvey-form.component';
//Land Procurement Imports ends

//Technical Additional Module Imports Starts
import { BillingComponent } from './app/technical/billing/billing.component';
import { IssueorderFormComponent } from './app/technical/work-order/issue-order/issueorder-form/issueorder-form.component';
import { GlobalDataFormComponent } from './app/technical/global-data/global-data-form/global-data-form.component';
import { MetricsGridComponent } from './app/technical/work-order/metrics/metrics-grid/metrics-grid.component';
import { MetricsFormComponent } from './app/technical/work-order/metrics/metrics-form/metrics-form.component';
import { DashboardTechComponent } from './app/technical/dashboard/dashboard.component';
import { ProjectProgressComponent } from './app/technical/project-progress/project-progress.component';
import { ScheduleFormComponent } from './app/technical/project-schedule/schedule-form/schedule-form.component';
import { WorkprogressFormComponent } from './app/technical/project-progress/work-progress/workprogress-form/workprogress-form.component';
import { RaBillFormComponent } from './app/technical/billing/ra-bill/ra-bill-form/ra-bill-form.component';
import { TenderBillFormComponent } from './app/technical/billing/tender-bill/tender-bill-form/tender-bill-form.component';
import { BillStatusComponent } from './app/technical/billing/bill-status/bill-status.component';
import { BillPaymentsFormComponent } from './app/technical/billing/bill-payments/bill-payments-form/bill-payments-form.component';
import { BillSummaryComponent } from './app/technical/billing/bill-summary/bill-summary.component';
import { BillPaybillsFormComponent } from './app/technical/billing/bill-paybills/bill-paybills-form/bill-paybills-form.component';
import { WorkslipStatementComponent } from './app/technical/billing/workslip-statement/workslip-statement.component';
import { ManualLotteryTokenComponent } from './app/allocation/manual-lottery/manual-lottery-token/manual-lottery-token.component';
import { CpCrViewComponent } from './app/legal/case-proceeding/cp-cr-grid/cp-cr-grid.component';
import { AdvocatesFormComponent } from './app/legal/advocates/advocates-form/advocates-form.component';
import { KhbnotificationltrComponent } from './app/applicant/khbnotificationltr/khbnotificationltr.component';
import { ApplicantQueryComponent } from './app/applicant/applicant-query/applicant-query.component';
import { DirectAllocationComponent } from './app/applicant/direct-allocation/direct-allocation.component';
//Technical Additional Module Imports Ends

import { AddBundleComponent } from './app/Godown/addBundle/addBundle.component';
import { GodownComponent } from './app/Godown/Godown.component';
import { AppRetRequestComponent } from './app/Godown/appretRequest/appretRequest.component';
import { GodownQueryComponent } from './app/Godown/query/query.component';
import { NoticeCancellationComponent } from './app/allocation/notice-cancellation/notice-cancellation.component';
import { NotieLetterComponent } from './app/pdf-forms/notie-letter/notie-letter.component';
import { OrderLetterComponent } from './app/pdf-forms/order-letter/order-letter.component';

import { BillsToFinanceComponent } from './app/legal/bills-to-finance/bills-to-finance.component';
import { GodownReportsComponent } from './app/Godown/godown-reports/godown-reports.component';
import { BundleReportsComponent } from './app/Godown/bundle-reports/bundle-reports.component';
import { SubmittedAppReportsComponent } from './app/Godown/submitted-app-reports/submitted-app-reports.component';
import { RequestAppRecordsComponent } from './app/Godown/request-app-records/request-app-records.component';
import { AllocationReportsComponent } from './app/allocation/allocation-reports/allocation-reports.component';
import { AllotedPropertyListComponent } from './app/allocation/alloted-property-list/alloted-property-list.component';
import { CancellationReportsComponent } from './app/allocation/cancellation-reports/cancellation-reports.component';
import { PrAllocatedPropListComponent } from './app/allocation/pr-allocated-prop-list/pr-allocated-prop-list.component';
import { PrVacantPropListComponent } from './app/allocation/pr-vacant-prop-list/pr-vacant-prop-list.component';
import { ReportsComponent } from './app/reports/reports.component';
import { DqVacantPropertyComponent } from './app/reports/dq-vacant-property/dq-vacant-property.component';
import { ClearVacantPropertyComponent } from './app/reports/clear-vacant-property/clear-vacant-property.component';
import { CornerVacantPropertyComponent } from './app/reports/corner-vacant-property/corner-vacant-property.component';
import { DistrictwiseVacantPropertyComponent } from './app/reports/districtwise-vacant-property/districtwise-vacant-property.component';
import { VacantCommercialPropertyComponent } from './app/reports/vacant-commercial-property/vacant-commercial-property.component';
import { AvailBlockedInterDqCornerComponent } from './app/reports/avail-blocked-inter-dq-corner/avail-blocked-inter-dq-corner.component';
import { IntermediateAvailableSitehouseflatsComponent } from './app/reports/intermediate-available-sitehouseflats/intermediate-available-sitehouseflats.component';
import { IntermediateBlockedSitehouseflatsComponent } from './app/reports/intermediate-blocked-sitehouseflats/intermediate-blocked-sitehouseflats.component';
import { BoardmeetinggridComponent } from './app/landprocurement/BoardMeet/boardmeetinggrid/boardmeetinggrid.component';
import { BoardmeetingComponent } from './app/landprocurement/BoardMeet/boardmeeting/boardmeeting.component';
import { BidderViewComponent } from './app/applicant/bidder-view/bidder-view.component';
import { PhaseGridComponent } from './app/master/phases/phase-grid/phase-grid.component';
import { PhaseFormComponent } from './app/master/phases/phase-form/phase-form.component';
import { SchemesGridComponent } from './app/master/schemes/schemes-grid/schemes-grid.component';
import { SchemesFormComponent } from './app/master/schemes/schemes-form/schemes-form.component';
import { offlineapplicationComponent } from './app/applicant/offline-application/offline-application.component';
import { ChangeRequestComponent } from './app/applicant/change-request/change-request.component';
import { AllotNotallotComponent } from './app/applicant/allot-notallot/allot-notallot.component';
import { LoginlocComponent } from './app/ultilities/loginloc/loginloc.component';
import { AllertComponent } from './app/allert/allert.component';
import { LogGridComponent } from './app/ultilities/auditTrail-log/loggrid.component';
import { WorkflowAlertComponent } from './app/ultilities/workflow-alert/workflow-alert/workflow-alert.component';
import { WorkflowAlertGridComponent } from './app/ultilities/workflow-alert/workflow-alert-grid/workflow-alert-grid.component';
import { LandProjectGridComponent } from './app/landprocurement/land-project/land-project-grid/land-project-grid.component';
import { LandProjectFormComponent } from './app/landprocurement/land-project/land-project-form/land-project-form.component';
import { LandProjectDetailsComponent } from './app/landprocurement/land-details/land-project-details/land-project-details.component';
import { LandTownPlanningGridComponent } from './app/landprocurement/land-to-town-planning/land-town-planning-grid/land-town-planning-grid.component';
import { ProjectReceivedLpGridComponent } from './app/planning/project-received-land-pro-details/project-received-lp-grid/project-received-lp-grid.component';
import { ProjectPhaseFormComponent } from './app/planning/project-phase-details/project-phase-form/project-phase-form.component';
// import { ProjectPhaseGridComponent } from './app/planning/project-phase-details/project-phase-grid/project-phase-grid.component';
import { LandTownPlanningFormComponent } from './app/landprocurement/land-to-town-planning/land-town-planning-form/land-town-planning-form.component';
import { ProjectPhaseGridComponent } from './app/planning/project-phase-details/project-phase-grid/project-phase-grid.component';
import { ReviseBasePriceComponent } from './app/applicant/revise-base-price/revise-base-price.component';
import { ReviseBaseGridComponent } from './app/applicant/revise-base-price/revise-base-grid/revise-base-grid.component';
import { ApplicantPaymentComponent } from './app/applicant/applicant-payment/applicant-payment.component';
import { UpdationApplicantFormComponent } from './app/applicant/updation-applicant-details/updation-applicant-form/updation-applicant-form.component';
import { ApplicantDetailsUpdateComponent } from './app/applicant/applicant-details-update/applicant-details-update.component';
import { OfflineApplicationGridComponent } from './app/applicant/offline-application/offline-application-grid/offline-application-grid.component';
import { LotteryReportComponent } from './app/allocation/lottery-report/lottery-report.component';
import { JointVentureComponent } from './app/landprocurement/joint-venture/joint-venture.component';
import { LpAgreementGridComponent } from './app/landprocurement/land-purchase/land-pur-agreements/lp-agreement-grid/lp-agreement-grid.component';
import { LpAgreementFormComponent } from './app/landprocurement/land-purchase/land-pur-agreements/lp-agreement-form/lp-agreement-form.component';
import { LpPurchaseGridComponent } from './app/landprocurement/land-purchase/land-pur-purchase/lp-purchase-grid/lp-purchase-grid.component';
import { LpPurchaseFormComponent } from './app/landprocurement/land-purchase/land-pur-purchase/lp-purchase-form/lp-purchase-form.component';
import { LpPaymentGridComponent } from './app/landprocurement/land-purchase/land-pur-payment/lp-payment-grid/lp-payment-grid.component';
import { LpPaymentFormComponent } from './app/landprocurement/land-purchase/land-pur-payment/lp-payment-form/lp-payment-form.component';
import { LpProfessionGridComponent } from './app/landprocurement/land-purchase/land-pur-profession/lp-profession-grid/lp-profession-grid.component';
import { LpProfessionFormComponent } from './app/landprocurement/land-purchase/land-pur-profession/lp-profession-form/lp-profession-form.component';
import { JvAgreementGridComponent } from './app/landprocurement/joint-venture/jv-agreements/jv-agreement-grid/jv-agreement-grid.component';
import { JvAgreementFormComponent } from './app/landprocurement/joint-venture/jv-agreements/jv-agreement-form/jv-agreement-form.component';
import { JvExceptenceGridComponent } from './app/landprocurement/joint-venture/jv-exceptence/jv-exceptence-grid/jv-exceptence-grid.component';
import { JvExceptenceFormComponent } from './app/landprocurement/joint-venture/jv-exceptence/jv-exceptence-form/jv-exceptence-form.component';
import { JvPossessionGridComponent } from './app/landprocurement/joint-venture/jv-possession/jv-possession-grid/jv-possession-grid.component';
import { JvPossessionFormComponent } from './app/landprocurement/joint-venture/jv-possession/jv-possession-form/jv-possession-form.component';
import { RecoveryComponent } from './app/recovery/recovery.component';
import { BuildingGridComponent } from './app/recovery/buildingdetails/building-grid/building-grid.component';
import { BuildingFormComponent } from './app/recovery/buildingdetails/building-form/building-form.component';
import { RateFixationGridComponent } from './app/recovery/rate-fixation/rate-fixation-grid/rate-fixation-grid.component';
import { RateFixationFormComponent } from './app/recovery/rate-fixation/rate-fixation-form/rate-fixation-form.component';
import { AgreementsAppComponent } from './app/recovery/agreements-app/agreements-app.component';
import { AgreementsGridComponent } from './app/recovery/Agreements/agreements-grid/agreements-grid.component';
import { AgreementsFormComponent } from './app/recovery/Agreements/agreements-form/agreements-form.component';
import { AgreementAppGridComponent } from './app/recovery/agreements-app/agreements-approval/agreement-app-grid/agreement-app-grid.component';
import { AgreementAppFormComponent } from './app/recovery/agreements-app/agreements-approval/agreement-app-form/agreement-app-form.component';
import { CustomerGridComponent } from './app/recovery/customer/customer-grid/customer-grid.component';
import { CustomerFormComponent } from './app/recovery/customer/customer-form/customer-form.component';
import { RequestPropertiesComponent } from './app/recovery/request-properties/request-properties.component';
import { RequestPropertyGridComponent } from './app/recovery/request-property/request-property-grid/request-property-grid.component';
import { RequestPropertyFormComponent } from './app/recovery/request-property/request-property-form/request-property-form.component';
import { RequestPropertyAppGridComponent } from './app/recovery/request-properties/request-property-approval/request-property-app-grid/request-property-app-grid.component';
import { RequestPropertyAppFormComponent } from './app/recovery/request-properties/request-property-approval/request-property-app-form/request-property-app-form.component';
import { PaymentReceiptApprovalComponent } from './app/recovery/payment-receipt-approval/payment-receipt-approval.component';
import { PaymentReceiptsGridComponent } from './app/recovery/Payment-Receipts/payment-receipts-grid/payment-receipts-grid.component';
import { PaymentReceiptsFormComponent } from './app/recovery/Payment-Receipts/payment-receipts-form/payment-receipts-form.component';
import { PaymentReceiptAppGirdComponent } from './app/recovery/payment-receipt-approval/payment-receipt-app-gird/payment-receipt-app-gird.component';
import { PaymentReceiptAppFormComponent } from './app/recovery/payment-receipt-approval/payment-receipt-app-form/payment-receipt-app-form.component';
import { PaymentChallApprovalComponent } from './app/recovery/payment-chall-approval/payment-chall-approval.component';
import { PaymentChallanGridComponent } from './app/recovery/payment-challan/payment-challan-grid/payment-challan-grid.component';
import { PaymentChallanFormComponent } from './app/recovery/payment-challan/payment-challan-form/payment-challan-form.component';
import { PaymentChallAppGridComponent } from './app/recovery/payment-chall-approval/payment-chall-app-grid/payment-chall-app-grid.component';
import { PaymentChallAppFormComponent } from './app/recovery/payment-chall-approval/payment-chall-app-form/payment-chall-app-form.component';
import { RenewalsGridComponent } from './app/recovery/Renewals/renewals-grid/renewals-grid.component';
import { RenewalsFormComponent } from './app/recovery/Renewals/renewals-form/renewals-form.component';
import { RecoveryReportGridComponent } from './app/recovery/recovery-reports/recovery-report-grid/recovery-report-grid.component';
import { BlockFormComponent } from './app/recovery/block/block-form/block-form.component';
import { BlockGridComponent } from './app/recovery/block/block-grid/block-grid.component';
import { PropertyGridComponent } from './app/recovery/property/property-grid/property-grid.component';
import { PropertyFormComponent } from './app/recovery/property/property-form/property-form.component';
import { PayrollMastersComponent } from './app/hrms/payroll/payroll-masters/payroll-masters.component';
import { AllowanceCodeGridComponent } from './app/hrms/payroll/payroll-masters/allowance-codes/allowance-code-grid/allowance-code-grid.component';
import { AllowanceCodeComponent } from './app/hrms/payroll/payroll-masters/allowance-codes/allowance-code/allowance-code.component';
import { DeductionCodeGridComponent } from './app/hrms/payroll/payroll-masters/deduction-codes/deduction-code-grid/deduction-code-grid.component';
import { DeductionCodeComponent } from './app/hrms/payroll/payroll-masters/deduction-codes/deduction-code/deduction-code.component';
import { FormulaGridComponent } from './app/hrms/payroll/payroll-masters/formula-details/formula-grid/formula-grid.component';
import { FormulaFormComponent } from './app/hrms/payroll/payroll-masters/formula-details/formula-form/formula-form.component';
import { OrganisationProfileComponent } from './app/hrms/payroll/organisation-profile/organisation-profile.component';
import { IncomeTaxGridComponent } from './app/hrms/payroll/organisation-profile/income-tax/income-tax-grid/income-tax-grid.component';
import { ProfessionalTaxGridComponent } from './app/hrms/payroll/organisation-profile/professional-tax/professional-tax-grid/professional-tax-grid.component';
import { ProfessionalTaxFormComponent } from './app/hrms/payroll/organisation-profile/professional-tax/professional-tax-form/professional-tax-form.component';
import { IncomeTaxFormComponent } from './app/hrms/payroll/organisation-profile/income-tax/income-tax-form/income-tax-form.component';
import { ControlDataComponent } from './app/hrms/payroll/organisation-profile/control-data/control-data.component';
import { PayMonthlyGridComponent } from './app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-grid/pay-monthly-grid.component';
import { PayMonthlyFormComponent } from './app/hrms/payroll/organisation-profile/pay-mothly-details/pay-monthly-form/pay-monthly-form.component';
import { EmpSalaryDetailsComponent } from './app/hrms/payroll/emp-salary-details/emp-salary-details.component';
import { EmpBasicDetailsGridComponent } from './app/hrms/payroll/emp-salary-details/emp-basic-details/emp-basic-details-grid/emp-basic-details-grid.component';
import { FixedAllowanceGridComponent } from './app/hrms/payroll/emp-salary-details/fixed-allowance/fixed-allowance-grid/fixed-allowance-grid.component';
import { FixedAllowanceFormComponent } from './app/hrms/payroll/emp-salary-details/fixed-allowance/fixed-allowance-form/fixed-allowance-form.component';
import { VariableAllowanceGridComponent } from './app/hrms/payroll/emp-salary-details/variable-allowance/variable-allowance-grid/variable-allowance-grid.component';
import { VariableAllowanceFormComponent } from './app/hrms/payroll/emp-salary-details/variable-allowance/variable-allowance-form/variable-allowance-form.component';
import { FixedDeductionGridComponent } from './app/hrms/payroll/emp-salary-details/fixed-deductions/fixed-deduction-grid/fixed-deduction-grid.component';
import { VariableDeductionGridComponent } from './app/hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-grid/variable-deduction-grid.component';
import { VariableDeductionFormComponent } from './app/hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-form/variable-deduction-form.component';
import { LoanDetFormComponent } from './app/hrms/payroll/emp-salary-details/loan-details/loan-det-form/loan-det-form.component';
import { EmpBasicDetailsFormComponent } from './app/hrms/payroll/emp-salary-details/emp-basic-details/emp-basic-details-form/emp-basic-details-form.component';
import { PayrollProcessDetailsMenuComponent } from './app/hrms/payroll/payroll-process-details/payroll-process-details-menu/payroll-process-details-menu.component';
import { PayrollPaymonthComponent } from './app/hrms/payroll/payroll-process-details/payroll-paymonth/payroll-paymonth.component';
import { PayrollAttendaceLeaveComponent } from './app/hrms/payroll/payroll-process-details/payroll-attendace-leave/payroll-attendace-leave.component';
import { PayrollProcessPayrollComponent } from './app/hrms/payroll/payroll-process-details/payroll-process-payroll/payroll-process-payroll.component';
import { PayrollFinalizePayrollComponent } from './app/hrms/payroll/payroll-process-details/payroll-finalize-payroll/payroll-finalize-payroll.component';
import { PayrollReportsMenuComponent } from './app/hrms/payroll/payroll-reports/payroll-reports-menu/payroll-reports-menu.component';
import { MasterReportsComponent } from './app/hrms/payroll/payroll-reports/master-reports/master-reports.component';
import { SummaryReportsComponent } from './app/hrms/payroll/payroll-reports/summary-reports/summary-reports.component';
import { MiscellaneousReportsComponent } from './app/hrms/payroll/payroll-reports/miscellaneous-reports/miscellaneous-reports.component';
import { VariableAllowdeductionComponent } from './app/hrms/payroll/variable-allowance-deduction-details/variable-allowdeduction/variable-allowdeduction.component';
import { IncometaxParameterComponent } from './app/hrms/payroll/incometax-parameter/incometax-parameter.component';
import { PayrollProcessComponent } from './app/hrms/payroll/payroll-process/payroll-process.component';
import { PayrollFinalizeComponent } from './app/hrms/payroll/payroll-finalize/payroll-finalize.component';
import { PayrollAuthorizeGridComponent } from './app/hrms/payroll/payroll-authorize/payroll-authorize-grid/payroll-authorize-grid.component';
import { PayrollAuthorizeFormComponent } from './app/hrms/payroll/payroll-authorize/payroll-authorize-form/payroll-authorize-form.component';
import { PayrollSanctionGridComponent } from './app/hrms/payroll/payroll-sanction/payroll-sanction-grid/payroll-sanction-grid.component';
import { PayrollSanctionFormComponent } from './app/hrms/payroll/payroll-sanction/payroll-sanction-form/payroll-sanction-form.component';
import { MonthlyAttDetComponent } from './app/hrms/payroll/monthly-attendance-details/monthly-att-det/monthly-att-det.component';
import { TransferAuthorizationGridComponent } from './app/hrms/transfer/transfer-authorization/transfer-authorization-grid/transfer-authorization-grid.component';
import { TransferAuthorizationFormComponent } from './app/hrms/transfer/transfer-authorization/transfer-authorization-form/transfer-authorization-form.component';
import { TransferSanctionGridComponent } from './app/hrms/transfer/transfer-sanction/transfer-sanction-grid/transfer-sanction-grid.component';
import { TransferSanctionFormComponent } from './app/hrms/transfer/transfer-sanction/transfer-sanction-form/transfer-sanction-form.component';
import { TransferRecordersGridComponent } from './app/hrms/transfer/transfer-recorders/transfer-recorders-grid/transfer-recorders-grid.component';
import { TransferRecordersFormComponent } from './app/hrms/transfer/transfer-recorders/transfer-recorders-form/transfer-recorders-form.component';
import { DeputaionComponent } from './app/hrms/deputaion/deputaion.component';
import { DeputationAuthorizationComponent } from './app/hrms/deputaion/deputation-authorization/deputation-authorization/deputation-authorization.component';
import { DeputationAuthorizationFormComponent } from './app/hrms/deputaion/deputation-authorization/deputation-authorization-form/deputation-authorization-form.component';
import { DeputaionSanctionGridComponent } from './app/hrms/deputaion/deputaion-sanction/deputaion-sanction-grid/deputaion-sanction-grid.component';
import { DeputaionSanctionFormComponent } from './app/hrms/deputaion/deputaion-sanction/deputaion-sanction-form/deputaion-sanction-form.component';
import { DeputationRecGridComponent } from './app/hrms/deputaion/deputaion-rec/deputation-rec-grid/deputation-rec-grid.component';
import { DeputationRecFormComponent } from './app/hrms/deputaion/deputaion-rec/deputation-rec-form/deputation-rec-form.component';
import { EmployeeClaimsComponent } from './app/hrms/employee-claims/employee-claims.component';
import { MedicalReimburesmentGridComponent } from './app/hrms/employee-claims/Medical-Reimbursment/medical-reimburesment-grid/medical-reimburesment-grid.component';
import { MedicalReimburesmentComponent } from './app/hrms/employee-claims/Medical-Reimbursment/medical-reimburesment/medical-reimburesment.component';
import { MedReimSanctionGridComponent } from './app/hrms/employee-claims/med-reim-sanction/med-reim-sanction-grid/med-reim-sanction-grid.component';
import { MedReimSanctionFormComponent } from './app/hrms/employee-claims/med-reim-sanction/med-reim-sanction-form/med-reim-sanction-form.component';
import { HtcLtcSanctionGridComponent } from './app/hrms/employee-claims/htc-ltc-sanction/htc-ltc-sanction-grid/htc-ltc-sanction-grid.component';
import { HtcLtcSanctionFormComponent } from './app/hrms/employee-claims/htc-ltc-sanction/htc-ltc-sanction-form/htc-ltc-sanction-form.component';
import { HtcLtcRecGridComponent } from './app/hrms/employee-claims/htc-ltc-rec/htc-ltc-rec--grid/htc-ltc-rec--grid.component';
import { HtcLtcRecFormComponent } from './app/hrms/employee-claims/htc-ltc-rec/htc-ltc-rec--form/htc-ltc-rec--form.component';
import { LeaveencashmentGridComponent } from './app/hrms/employee-claims/Leave Encashment/leaveencashment-grid/leaveencashment-grid.component';
import { LeaveencashmentComponent } from './app/hrms/employee-claims/Leave Encashment/leaveencashment/leaveencashment.component';
import { MedicalReimbursmentRecordsGridComponent } from './app/hrms/employee-claims/medical-reimbursment-records/medical-reimbursment-records-grid/medical-reimbursment-records-grid.component';
import { MedicalReimbursmentRecordsFormComponent } from './app/hrms/employee-claims/medical-reimbursment-records/medical-reimbursment-records-form/medical-reimbursment-records-form.component';
import { MedReimAuthorizationComponent } from './app/hrms/employee-claims/med-reim-authorization/med-reim-authorization/med-reim-authorization.component';
import { HtcLtcAuthComponent } from './app/hrms/employee-claims/htc-ltc-authorization/htc-ltc-auth/htc-ltc-auth.component';
import { LeaveEncashAuthComponent } from './app/hrms/employee-claims/leave-encash-authorization/leave-encash-auth/leave-encash-auth.component';
import { LeaveEncashSanctionGridComponent } from './app/hrms/employee-claims/leave-encash-sanction/leave-encash-sanction-grid/leave-encash-sanction-grid.component';
import { LeaveEncashSanctionFormComponent } from './app/hrms/employee-claims/leave-encash-sanction/leave-encash-sanction-form/leave-encash-sanction-form.component';
import { LeaveEncashmentRecGridComponent } from './app/hrms/employee-claims/leave-encashment-rec/leave-encashment-rec-grid/leave-encashment-rec-grid.component';
import { LeaveEncashmentRecFormComponent } from './app/hrms/employee-claims/leave-encashment-rec/leave-encashment-rec-form/leave-encashment-rec-form.component';
import { TrainingComponent } from './app/hrms/Training/training.component';
import { TrainingApprovalGridComponent } from './app/hrms/Training/training-approval/training-approval-grid/training-approval-grid.component';
import { TrainingApprovalFormComponent } from './app/hrms/Training/training-approval/training-approval-form/training-approval-form.component';
import { TrainingSanctionGridComponent } from './app/hrms/Training/training-sanction/training-sanction-grid/training-sanction-grid.component';
import { TrainingSanctionFormComponent } from './app/hrms/Training/training-sanction/training-sanction-form/training-sanction-form.component';
import { TrainingRecordGridComponent } from './app/hrms/Training/training-record/training-record-grid/training-record-grid.component';
import { DepartmentalExamComponent } from './app/hrms/Departmental-Exam/departmental-exam.component';
import { DeptExamAuthComponent } from './app/hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth/dept-exam-auth.component';
import { DeptExamAuthFormComponent } from './app/hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth-form/dept-exam-auth-form.component';
import { DeptExamSanctionGridComponent } from './app/hrms/Departmental-Exam/dept-exam-sanction/dept-exam-sanction-grid/dept-exam-sanction-grid.component';
import { DeptExamSanctionFormComponent } from './app/hrms/Departmental-Exam/dept-exam-sanction/dept-exam-sanction-form/dept-exam-sanction-form.component';
import { DeptExamRecordGridComponent } from './app/hrms/Departmental-Exam/dept-exam-record/dept-exam-record-grid/dept-exam-record-grid.component';
import { DeptExamRecordFromComponent } from './app/hrms/Departmental-Exam/dept-exam-record/dept-exam-record-from/dept-exam-record-from.component';
import { NominationComponent } from './app/hrms/Nomination/nomination.component';
import { NominationApplicationGridComponent } from './app/hrms/Nomination/Nomination-App/nomination-application-grid/nomination-application-grid.component';
import { NominationApplicationComponent } from './app/hrms/Nomination/Nomination-App/nomination-application/nomination-application.component';
import { NominationApprovalGridComponent } from './app/hrms/Nomination/nomination-approval/nomination-approval-grid/nomination-approval-grid.component';
import { NominationApprovalFormComponent } from './app/hrms/Nomination/nomination-approval/nomination-approval-form/nomination-approval-form.component';
import { NominationSanGridComponent } from './app/hrms/Nomination/nomination-san/nomination-san-grid/nomination-san-grid.component';
import { NominationRecGridComponent } from './app/hrms/Nomination/nomination-rec/nomination-rec-grid/nomination-rec-grid.component';
import { DepartEnquiryMenuComponent } from './app/hrms/depart-enquiry/depart-enquiry-menu/depart-enquiry-menu.component';
import { ComplaintsRegGridComponent } from './app/hrms/depart-enquiry/complaints-registration/complaints-reg-grid/complaints-reg-grid.component';
import { ComplaintsRegFormComponent } from './app/hrms/depart-enquiry/complaints-registration/complaints-reg-form/complaints-reg-form.component';
import { ShowCaseGridComponent } from './app/hrms/depart-enquiry/show-case-noties/show-case-grid/show-case-grid.component';
import { ShowCaseFormComponent } from './app/hrms/depart-enquiry/show-case-noties/show-case-form/show-case-form.component';
import { ShowCauseAckGridComponent } from './app/hrms/depart-enquiry/showcause-notice-acknowledgement-dgos-reply/show-cause-ack-grid/show-cause-ack-grid.component';
import { ShowCauseAckFormComponent } from './app/hrms/depart-enquiry/showcause-notice-acknowledgement-dgos-reply/show-cause-ack-form/show-cause-ack-form.component';
import { EnquiryProceedingGridComponent } from './app/hrms/depart-enquiry/enquiry-proceedings/enquiry-proceeding-grid/enquiry-proceeding-grid.component';
import { EnquiryProceedingFormComponent } from './app/hrms/depart-enquiry/enquiry-proceedings/enquiry-proceeding-form/enquiry-proceeding-form.component';
import { InitiateDepartEnquiryGridComponent } from './app/hrms/depart-enquiry/initiate-depart-enquiry/initiate-depart-enquiry-grid/initiate-depart-enquiry-grid.component';
import { InitiateDepartEnquiryFormComponent } from './app/hrms/depart-enquiry/initiate-depart-enquiry/initiate-depart-enquiry-form/initiate-depart-enquiry-form.component';
import { ComplaintRegAuthComponent } from './app/hrms/depart-enquiry/complaint-reg-authorization/complaint-reg-auth/complaint-reg-auth.component';
import { ComplaintRegAuthFormComponent } from './app/hrms/depart-enquiry/complaint-reg-authorization/complaint-reg-auth-form/complaint-reg-auth-form.component';
import { ScnAuthorizationComponent } from './app/hrms/depart-enquiry/scn-authorization/scn-authorization/scn-authorization.component';
import { ScnAuthorizationFormComponent } from './app/hrms/depart-enquiry/scn-authorization/scn-authorization-form/scn-authorization-form.component';
import { ScnRemainderComponent } from './app/hrms/depart-enquiry/scn-authorization/scn-remainder/scn-remainder.component';
import { ScnRemainderFormComponent } from './app/hrms/depart-enquiry/scn-authorization/scn-remainder-form/scn-remainder-form.component';
import { EnquiryCloserGridComponent } from './app/hrms/depart-enquiry/enquiry-closure/enquiry-closer-grid/enquiry-closer-grid.component';
import { EnquiryCloserFormComponent } from './app/hrms/depart-enquiry/enquiry-closure/enquiry-closer-form/enquiry-closer-form.component';
import { ExternalEnquiryFormComponent } from './app/hrms/depart-enquiry/external-enquiry/external-enquiry-form/external-enquiry-form.component';
import { ExternalEnquiryGridComponent } from './app/hrms/depart-enquiry/external-enquiry/external-enquiry-grid/external-enquiry-grid.component';
import { ExternalEnquiryClosureGridComponent } from './app/hrms/depart-enquiry/external-enquiry-closure/external-enquiry-closure-grid/external-enquiry-closure-grid.component';
import { ExternalEnquiryClosureFormComponent } from './app/hrms/depart-enquiry/external-enquiry-closure/external-enquiry-closure-form/external-enquiry-closure-form.component';
import { AttendanceLeavesComponent } from './app/hrms/Attendance-Leaves/attendance-leaves.component';
import { DailyAttendanceGridComponent } from './app/hrms/Attendance-Leaves/daily-attendance/daily-attendance-grid/daily-attendance-grid.component';
import { DailyAttendanceFormComponent } from './app/hrms/Attendance-Leaves/daily-attendance/daily-attendance-form/daily-attendance-form.component';
import { DailyAttendanceOutGridComponent } from './app/hrms/Attendance-Leaves/daily-attendance-out/daily-attendance-out-grid/daily-attendance-out-grid.component';
import { DailyAttendanceOutFormComponent } from './app/hrms/Attendance-Leaves/daily-attendance-out/daily-attendance-out-form/daily-attendance-out-form.component';
import { LeaveTypeGridComponent } from './app/hrms/Attendance-Leaves/Leaves/leave-type-grid/leave-type-grid.component';
import { LeaveTypeComponent } from './app/hrms/Attendance-Leaves/Leaves/leave-type/leave-type.component';
import { LeaveAuthGridComponent } from './app/hrms/Attendance-Leaves/leave-authorization/leave-auth-grid/leave-auth-grid.component';
import { LeaveAuthFormComponent } from './app/hrms/Attendance-Leaves/leave-authorization/leave-auth-form/leave-auth-form.component';
import { LeaveSanctionGridComponent } from './app/hrms/Attendance-Leaves/leave-sanction/leave-sanction-grid/leave-sanction-grid.component';
import { MonthlyLeaveAttenGridComponent } from './app/hrms/Attendance-Leaves/monthly-leave-atten/monthly-leave-atten-grid/monthly-leave-atten-grid.component';
import { LeaveSanctionFormComponent } from './app/hrms/Attendance-Leaves/leave-sanction/leave-sanction-form/leave-sanction-form.component';
import { TimeRollGenGridComponent } from './app/hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-grid/time-roll-gen-grid.component';
import { TimeRollGenFormComponent } from './app/hrms/Attendance-Leaves/time-roll-generation/time-roll-gen-form/time-roll-gen-form.component';
import { TimeRollApprveGridComponent } from './app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-grid/time-roll-apprve-grid.component';
import { TimeRollApprveFormComponent } from './app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-form/time-roll-apprve-form.component';
import { TimeRollSanGridComponent } from './app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-grid/time-roll-san-grid.component';
import { TimeRollSanFormComponent } from './app/hrms/Attendance-Leaves/time-roll-sanctions/time-roll-san-form/time-roll-san-form.component';
import { TimeRollFinGridComponent } from './app/hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-grid/time-roll-fin-grid.component';
import { TimeRollFinFormComponent } from './app/hrms/Attendance-Leaves/time-roll-finalization/time-roll-fin-form/time-roll-fin-form.component';
import { TimeRollUnintiGridComponent } from './app/hrms/Attendance-Leaves/time-roll-unintigrated/time-roll-uninti-grid/time-roll-uninti-grid.component';
import { TimeRollUnintiFormComponent } from './app/hrms/Attendance-Leaves/time-roll-unintigrated/time-roll-uninti-form/time-roll-uninti-form.component';
import { LeaveCreditComponent } from './app/hrms/Leave-Credit/leave-credit.component';
import { LeavecreditComponent } from './app/hrms/Leave-Credit/leave-credits/leavecredit/leavecredit.component';
import { LeavecreditGridComponent } from './app/hrms/Leave-Credit/leave-credits/leavecredit-grid/leavecredit-grid.component';
import { LeaveCreditAuthComponent } from './app/hrms/Leave-Credit/leave-credit-authorization/leave-credit-auth/leave-credit-auth.component';
import { LeaveCreditAuthFormComponent } from './app/hrms/Leave-Credit/leave-credit-authorization/leave-credit-auth-form/leave-credit-auth-form.component';
import { LeaveCreditSanctionGridComponent } from './app/hrms/Leave-Credit/leave-credit-sanction/leave-credit-sanction-grid/leave-credit-sanction-grid.component';
import { LeaveCreditSanctionFormComponent } from './app/hrms/Leave-Credit/leave-credit-sanction/leave-credit-sanction-form/leave-credit-sanction-form.component';
import { LeaveCreditBulkComponent } from './app/hrms/Leave-Credit/leave-credit-bulk/leave-credit-bulk/leave-credit-bulk.component';
import { LeaveCreditBulkFormComponent } from './app/hrms/Leave-Credit/leave-credit-bulk/leave-credit-bulk-form/leave-credit-bulk-form.component';
import { BulkLeaveCreditApprovalComponent } from './app/hrms/Leave-Credit/bulk-leave-credit-approval/bulk-leave-credit-approval.component';
import { BulkLeaveCreditSanctionComponent } from './app/hrms/Leave-Credit/bulk-leave-credit-sanction/bulk-leave-credit-sanction.component';
import { MonthlyAttendanceComponent } from './app/hrms/serviceregister/Monthly Attendance/monthly-attendance/monthly-attendance.component';
import { MonthlyAttendanceGridComponent } from './app/hrms/serviceregister/Monthly Attendance/monthly-attendance-grid/monthly-attendance-grid.component';
import { PromotionsComponent } from './app/hrms/Promotions/promotions.component';
import { PromotionGridComponent } from './app/hrms/Promotions/Promotions/promotion-grid/promotion-grid.component';
import { PromotionComponent } from './app/hrms/Promotions/Promotions/promotion/promotion.component';
import { PromotionAuthGridComponent } from './app/hrms/Promotions/promotion-authorization/promotion-auth-grid/promotion-auth-grid.component';
import { PromotionAuthFormComponent } from './app/hrms/Promotions/promotion-authorization/promotion-auth-form/promotion-auth-form.component';
import { PromotionsSanctionGridComponent } from './app/hrms/Promotions/promotions-sanction/promotions-sanction-grid/promotions-sanction-grid.component';
import { PromotionsSanctionFormComponent } from './app/hrms/Promotions/promotions-sanction/promotions-sanction-form/promotions-sanction-form.component';
import { IncrementsComponent } from './app/hrms/Increments/increments.component';
import { GenIncrListGridComponent } from './app/hrms/Increments/generate-increment-list/gen-incr-list-grid/gen-incr-list-grid.component';
import { GenIncrListComponent } from './app/hrms/Increments/generate-increment-list/gen-incr-list/gen-incr-list.component';
import { IncrListAuthGridComponent } from './app/hrms/Increments/increment-list-authorization/incr-list-auth-grid/incr-list-auth-grid.component';
import { IncrListAuthComponent } from './app/hrms/Increments/increment-list-authorization/incr-list-auth/incr-list-auth.component';
import { IncrementsSanctionGridComponent } from './app/hrms/Increments/increments-sanction/increments-sanction-grid/increments-sanction-grid.component';
import { IncrementsSanctionFormComponent } from './app/hrms/Increments/increments-sanction/increments-sanction-form/increments-sanction-form.component';
import { IncrementPostingGridComponent } from './app/hrms/Increments/increment-posting/increment-posting-grid/increment-posting-grid.component';
import { IncrementPostingFormComponent } from './app/hrms/Increments/increment-posting/increment-posting-form/increment-posting-form.component';
import { RtiComponent } from './app/hrms/RTI/rti/rti.component';
import { RtiGridComponent } from './app/hrms/RTI/rti-grid/rti-grid.component';
import { EmployeeSeparationComponent } from './app/hrms/Employee-Separation/employee-separation.component';
import { EmpRetirementListComponent } from './app/hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list/emp-retirement-list.component';
import { EmpSeparationGridComponent } from './app/hrms/Employee-Separation/emp-separation/emp-separation-grid/emp-separation-grid.component';
import { EmpSeparationComponent } from './app/hrms/Employee-Separation/emp-separation/emp-separation/emp-separation.component';
import { EmpSepAuthComponent } from './app/hrms/Employee-Separation/emp-sep-authorization/emp-sep-auth/emp-sep-auth.component';
import { EmpSepAuthFormComponent } from './app/hrms/Employee-Separation/emp-sep-authorization/emp-sep-auth-form/emp-sep-auth-form.component';
import { PoliceVerificationComponent } from './app/hrms/serviceregister/Police Verification/police-verification/police-verification.component';
import { LeaveBalDetFormComponent } from './app/hrms/serviceregister/leave-balance-details/leave-bal-det-form/leave-bal-det-form.component';
import { LeaveBalDetGridComponent } from './app/hrms/serviceregister/leave-balance-details/leave-bal-det-grid/leave-bal-det-grid.component';
import { PoliceVerificationGridComponent } from './app/hrms/serviceregister/Police Verification/police-verification-grid/police-verification-grid.component';
import { ExperiencedetailsFormComponent } from './app/hrms/serviceregister/experiencedetails/experiencedetails-form/experiencedetails-form.component';
import { ExperiencedetailsGridComponent } from './app/hrms/serviceregister/experiencedetails/experiencedetails-grid/experiencedetails-grid.component';
import { AddressDetailsFormComponent } from './app/hrms/serviceregister/address-details/address-details-form/address-details-form.component';
import { AddressDetailsComponent } from './app/hrms/serviceregister/address-details/address-details/address-details.component';
import { ServiceRegViewFormComponent } from './app/hrms/serviceregister/service-register-views/service-reg-view-form/service-reg-view-form.component';
import { MasterDisplayComponent } from './app/master/master-display/master-display.component';
import { HospitalGridComponent } from './app/master/hospitals/hospital-grid/hospital-grid.component';
import { HospitalFormComponent } from './app/master/hospitals/hospital-form/hospital-form.component';
import { MasterCalendarGridComponent } from './app/master/master-calendar/master-calendar-grid/master-calendar-grid.component';
import { MasterCalendarFormComponent } from './app/master/master-calendar/master-calendar-form/master-calendar-form.component';
import { DeputationInGridComponent } from './app/hrms/deputaion/deputation-in/deputation-in-grid/deputation-in-grid.component';
import { DeputationInFormComponent } from './app/hrms/deputaion/deputation-in/deputation-in-form/deputation-in-form.component';
import { DeputationOutGridComponent } from './app/hrms/deputaion/deputation-out/deputation-out-grid/deputation-out-grid.component';
import { DeputationOutFormComponent } from './app/hrms/deputaion/deputation-out/deputation-out-form/deputation-out-form.component';
import { TrainingDetailsGridComponent } from './app/hrms/Training/training-details/training-details-grid/training-details-grid.component';
import { TrainingDetailsFormComponent } from './app/hrms/Training/training-details/training-details-form/training-details-form.component';
import { DepartmentalExamDetailsGridComponent } from './app/hrms/Departmental-Exam/departmental-exam-details/departmental-exam-details-grid/departmental-exam-details-grid.component';
import { DepartmentalExamDetailsFormComponent } from './app/hrms/Departmental-Exam/departmental-exam-details/departmental-exam-details-form/departmental-exam-details-form.component';
import { HtcLtcGridComponent } from './app/hrms/employee-claims/htc-ltc/htc-ltc-grid/htc-ltc-grid.component';
import { HtcLtcFormComponent } from './app/hrms/employee-claims/htc-ltc/htc-ltc-form/htc-ltc-form.component';
import { AuctionedPropertiesCancelComponent } from './app/allocation/auctioned-properties-cancel/auctioned-properties-cancel.component';
import { ViewAuctionedPpropertiesComponent } from './app/allocation/view-auctioned-properties/view-auctioned-properties.component';
import { PaymentFormComponent } from './app/allocation/payment-form/payment-form.component';
import { CheckoutFormComponent } from './app/allocation/checkout-form/checkout-form.component';

//lakshman



// var data = localStorage.getItem("accessToken");
// var defaultPage;
// if(data) defaultPage = "/home"; else defaultPage = "/login";

export const appRoutes: Routes = [
    {
        path: 'home', component: HomepageComponent, canActivate: [AuthGuard],
        children: [
            {
                path: '', component: DashboardComponent
            },

            {
                path: 'alert', component: AllertComponent
            },

            {
                path: 'property', component: AllocationComponent,
                children: [{ path: '', component: PropertyregisterGridComponent },
                { path: 'propertyform', component: PropertyregisterFormComponent }
                ]

            },

            {
                path: 'allotment', component: AllocationComponent,
                children: [{ path: '', component: ApplicationformComponent },
                { path: 'applicationedit/:APP_Id/:NO_Id/:PD_Id', component: ApplicationformComponent }
                ]
            },

            {
                path: 'application-form/view', component: ApplicationformComponent
            },

            {
                path: 'installment-due', component: AllocationComponent,
                children: [{ path: '', component: InstallmentDueComponent }]
            },

            {
                path: 'provision-allotment', component: AllocationComponent,
                children: [{ path: '', component: ProvisionAllotmentComponent }]
            },

            {
                path: 'maintainance-fee', component: AllocationComponent,
                children: [{ path: '', component: MaintainanceFeeComponent }]
            },

            {
                path: 'khbnotification', component: AllocationComponent,
                children: [{ path: '', component: GridComponent },
                { path: 'khbnotificationform', component: FormComponent },
                { path: 'khbnotificationform/:DSWOId_NO_Id/:mode', component: FormComponent }
                ]
            },

            //lakshman
            {
                path: 'auctionedpropertiescancel', component: AllocationComponent,               
                children: [{ path: '', component: AuctionedPropertiesCancelComponent }]
            },

            {               
                path: 'viewauctionedproperties/:PR_Id', component: AllocationComponent, 
                children: [{ path: '', component: ViewAuctionedPpropertiesComponent }]
            },

            {
                path: 'paymentform', component: AllocationComponent,               
                children: [{ path: '', component: PaymentFormComponent }]
            },
            {               
                path: 'checkoutform/:TransactionId', component: AllocationComponent, 
                children: [{ path: '', component: CheckoutFormComponent }]
            },

            {
                path: 'pre-allotment', component: AllocationComponent,
                children: [{ path: '', component: PrAllotmentGridComponent },
                { path: 'pre-allotmentform/:PD_Id', component: PrAllotmentFormComponent },
                { path: 'pre-allotmentformnotsent/:PD_Id', component: PrAllotmentNotsentComponent },
                { path: 'pre-allotmentall/:PD_Id', component: PropertyPlanAlllistComponent }

                ]
            },

            {
                path: 'sms', component: AllocationComponent,
                children: [{ path: '', component: SmsGridComponent },
                { path: 'sms-form', component: SmsFormComponent }
                ]
            },

            {
                path: 'campaign-details', component: AllocationComponent,
                children: [{ path: '', component: CampaignDetailsComponent }]
            },

            {
                path: 'websitenews', component: AllocationComponent,
                children: [{ path: '', component: WebsitenewsGridComponent },
                { path: 'websitenews-form', component: WebsitenewsFormComponent }
                ]
            },

            {
                path: 'scrutiny', component: AllocationComponent,
                children: [{ path: '', component: ScrutinyComponent },
                { path: 'scrutinized/:S_NotificationID/:S_ProjectID/:S_CA_Id_FK/:S_Reservation_Id_FK/:S_Property_Type', component: ScrutinyComponent },
                { path: 'scrutiny-view/:APP_Id/:S_NotificationID/:S_ProjectID/:S_CA_Id_FK/:S_Reservation_Id_FK/:S_Property_Type', component: ScrutinyViewComponent },
                ]
            },
            // {
            //     path:'finalList',component:AllocationComponent,
            //     children: [{ path: '', component: FinalListComponent },
            //     ]
            // },

            {
                path: 'allot', component: AllocationComponent,
                children: [
                    {
                        path: '', component: LotteryComponent,
                        children: [
                            { path: '', component: ELotteryComponent },
                            { path: 'manual-grid', component: ManualGridComponent },
                            { path: 'manual-form', component: ManualFormComponent },
                            { path: 'manual-form/:LO_Id/:mode', component: ManualFormComponent }
                        ]
                    }
                ]
            },

            {
                path: 'allotmentlist', component: AllocationComponent,
                children: [{ path: '', component: AllottmentListComponent }]
            },

            {
                path: 'not-alloted', component: AllocationComponent,
                children: [{ path: '', component: NotAllotedListComponent }]
            },

            {
                path: 'notallotedrefund', component: AllocationComponent,
                children: [{ path: '', component: NotAllotedRefundComponent },
                { path: 'refund-form', component: NotAllotedRefundFormComponent },
                { path: 'refund-form/:NAR_Id/:mode', component: NotAllotedRefundFormComponent }
                ]
            },
            {
                path: 'installment', component: AllocationComponent,
                children: [{ path: '', component: InstallmentconfigComponent }]
            },

            {
                path: 'allotmentcancellation', component: AllocationComponent,
                children: [{ path: '', component: AllotmentProjectListComponent },
                { path: 'project-names/:Sch_Id', component: ProjectNamesComponent },
                { path: 'allotted-vacant/:PD_Id/:PD_Project_Name/:Phase_Name/:Sch_Id', component: AllotmentAllottedPropertyComponent },
                { path: 'payment-details', component: PaymentDetailsComponent },
                { path: 'saledeed-details', component: SaledeedDetailsComponent },
                { path: 'cancel-allotment/:APP_No/:PR_Id/:PD_Id/:PD_Project_Name/:Phase_Name/:Sch_Id', component: CancelAllotmentComponent },
                { path: 'cancel-allotment/:type/:APP_No/:PR_Id/:Can_Type/:PAC_Id', component: CancelAllotmentComponent }

                ]
            },

            {
                path: 're-allotment', component: AllocationComponent,
                children: [{ path: '', component: ReAllotmentComponent }]
            },

            {
                path: 'lottery-report', component: AllocationComponent,
                children: [{ path: '', component: LotteryReportComponent }]
            },

            {
                path: 'printallotmentletter', component: AllocationComponent,
                children: [{ path: '', component: PrintAllotmentletterComponent }]
            },

            {
                path: 'change-property', component: AllocationComponent,
                children: [{ path: '', component: ChangePropertygridComponent },
                { path: 'change-propertyform', component: ChangePropertyformComponent }
                ]
            },
            {
                path: 'waiting-list', component: AllocationComponent,
                children: [{ path: '', component: WaitingListComponent }]
            },
            {
                path: 'defaulter', component: AllocationComponent,
                children: [{ path: '', component: DefaultersComponent }]
            },
            {
                path: 'saledeed', component: AllocationComponent,
                children: [{ path: '', component: SaledeedComponent }
                ]
            },

            {
                path: 'allocationreports', component: AllocationComponent,
                children: [{ path: '', component: AllocationReportsComponent }]
            },


            // {
            //     path: 'saledeed', component: AllocationComponent,
            //     children: [
            //         {
            //             path: '', component: SaledeedComponent,
            //             children: [
            //                 {
            //                     path: '', component: SoldpropertyComponent,
            //                 },
            //                 {
            //                     path: 'sale', component: SaleComponent,
            //                 }
            //             ]
            //         }
            //     ]
            // },

            {
                path: 'e-khata', component: AllocationComponent,
                children: [{ path: '', component: EKhataComponent }]
            },
            {
                path: 'noticecancellation', component: AllocationComponent,
                children: [{ path: '', component: NoticeCancellationComponent }]
            },
            {
                path: 'workflow', component: UltilitiesComponent,
                children: [
                    { path: 'workflow-form', component: WorkflowAlertComponent },
                    { path: '', component: WorkflowAlertGridComponent },
                ]
            },


            {
                path: 'password', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },
            {
                path: 'login-loc', component: UltilitiesComponent,
                children: [{ path: '', component: LoginlocComponent }]
            },


            {
                path: 'log-view', component: UltilitiesComponent,
                children: [{ path: '', component: LogGridComponent },
                { path: 'reroute/:mode', component: LogGridComponent }]
            },

            {
                path: 'password/:userId', component: UltilitiesComponent,
                children: [{ path: '', component: ChangePasswordComponent }]
            },

            {
                path: 'rolesgrid', component: UltilitiesComponent,
                children: [{ path: '', component: RolesGridComponent },
                { path: 'rolesform', component: RolesFormComponent },
                { path: 'rolesform/:roleId/:mode', component: RolesFormComponent }
                ]
            },

            {
                path: 'user', component: UltilitiesComponent,
                children: [{ path: '', component: UserGridComponent },
                { path: 'userform', component: UserFormComponent },
                { path: 'userform/:Id/:mode', component: UserFormComponent }
                ]
            },

            {
                path: 'claims', component: UltilitiesComponent,
                children: [{ path: '', component: ClaimGridComponent },
                { path: 'claimform/:roleId/:roleName', component: ClaimFormComponent }
                ]
            },

            // {
            //     path: 'claims', component: UltilitiesComponent,
            //     children: [{ path: '', component: ClaimGridComponent },
            //     { path: 'claimform/:roleId/:roleName/:officeName', component: ClaimFormComponent }
            //     ]
            // },

            {
                path: 'office', component: MasterComponent,
                children: [{ path: '', component: OfficeGridComponent },
                { path: 'officeform', component: OfficeFormComponent },
                { path: 'officeform/:OfficeId/:mode', component: OfficeFormComponent }
                ]
            },

            {
                path: 'project-master', component: MasterComponent,
                children: [{ path: '', component: ProjectmasterGridComponent },
                { path: 'project-master-form', component: ProjectmasterFormComponent }
                ]
            },

            {
                path: 'district', component: MasterComponent,
                children: [{ path: '', component: DistrictViewComponent },
                { path: 'district-form', component: DistrictFormComponent },
                { path: 'district-form/:DI_Id/:mode', component: DistrictFormComponent }
                ]
            },
            {
                path: 'filemaster', component: MasterComponent,
                children: [{ path: '', component: FilemasterGridComponent },
                { path: 'filemaster-form', component: FilemasterFormComponent },
                { path: 'filemaster-form/:File_Id/:mode', component: FilemasterFormComponent }
                ]
            },

            {
                path: 'court', component: MasterComponent,
                children: [{ path: '', component: CourtViewComponent },
                { path: 'court-form', component: CourtFormComponent },
                { path: 'court-form/:Court_Id/:mode', component: CourtFormComponent }
                ]
            },

            {
                path: 'courttype', component: MasterComponent,
                children: [{ path: '', component: CourttypeViewComponent },
                { path: 'courttype-form', component: CourttypeFormComponent },
                { path: 'courttype-form/:CourtT_Id/:mode', component: CourttypeFormComponent }
                ]
            },

            // {
            //     path: 'employedadvocates', component: MasterComponent,
            //     children: [{ path: '', component: AdvocatesViewComponent },
            //     { path: 'employedadvocates-form', component: AdvocatesFormComponent }
            //     ]
            // },

            {
                path: 'dept', component: MasterComponent,
                children: [{ path: '', component: DeptViewComponent },
                { path: 'dept-form', component: DeptFormComponent },
                { path: 'dept-form/:Department_Id/:mode', component: DeptFormComponent }
                ]
            },

            // HRMS Routes start
            
            {
                path: 'phases', component: MasterComponent,
                children: [{ path: '', component: PhaseGridComponent },
                { path: 'phase-form', component: PhaseFormComponent },
                { path: 'phase-form/:Phase_Id/:mode', component: PhaseFormComponent }
                ]
            },
            {
                path: 'schemes-master', component: MasterComponent,
                children: [{ path: '', component: SchemesGridComponent },
                { path: 'scheme-master-form', component: SchemesFormComponent },
                { path: 'scheme-master-form/:Sch_Id/:mode', component: SchemesFormComponent }
                ]
            },
            
            
            // HRMS Routes end

            //Applicant Routes
            {
                path: 'profile', component: ApplicantComponent,
                children: [{ path: '', component: ProfileComponent }]
            },
            {
                path: 'offline-application-grid', component: ApplicantComponent,
                children: [
                    { path: '', component: OfflineApplicationGridComponent },
                    { path: 'offline-application', component: offlineapplicationComponent },
                    { path: 'offline-application/:APP_No/:mode', component: offlineapplicationComponent },
                ]
            },
            {
                path: 'change-request', component: ApplicantComponent,
                children: [{ path: '', component: ChangeRequestComponent }]
            },
            {
                path: 'allotted-notallotted', component: ApplicantComponent,
                children: [{ path: '', component: AllotNotallotComponent }]
            },

            {
                path: 'apply', component: ApplicantComponent,
                children: [
                    { path: '', component: ActivelistComponent },
                    { path: 'application-form/:NO_Id/:PD_Id', component: ApplicationformComponent }
                ]
            },

            {
                path: 'applicationstatus', component: ApplicantComponent,
                children: [{ path: '', component: ApplicationstatusComponent }]
            },

            {
                path: 'applicant', component: ApplicantComponent,
                children: [{ path: 'applicantview/:APP_Id/:NO_Id/:mode', component: ApplicationViewComponent },
                { path: 'applicantviewLottery/:APP_Id/:NO_Id/:mode', component: ApplicationViewComponent },
                    // { path: 'applicantview/:APP_Id/:NO_Id/:mode', component: ApplicationViewComponent }
                ]
            },

            {
                path: 'revise-base-price', component: ApplicantComponent,
                children: [{ path: '', component: ReviseBasePriceComponent },
                { path: 'revise-base-grid', component: ReviseBaseGridComponent },
                { path: 'revise-base-grid/:RBP_Id/:mode', component: ReviseBaseGridComponent },
                ]
            },

            {
                path: 'updation-applicant', component: ApplicantComponent,
                children: [
                    { path: '', component: ApplicantDetailsUpdateComponent },
                ]
            },
            {
                path: 'payment-id', component: ApplicantComponent,
                children: [{ path: '', component: ApplicantPaymentComponent }]
            },

            // {

            //     path: 'applicantview', component: ApplicantComponent,
            //     children: [{ path: 'APP_Id', component: ApplicationViewComponent }]

            // },
            // { path: 'applicantview/APP_Id', component: ApplicantComponent },
            // --test
            {
                path: 'applicantviews', component: ApplicantComponent,
                children: [{ path: '', component: ApplicationViewComponent }]
            },
            //--

            {
                path: 'change-address', component: ApplicantComponent,
                children: [{ path: '', component: ChangeAddressComponent }]
            },
            {
                path: 'bidder-view', component: ApplicantComponent,
                children: [{ path: '', component: BidderViewComponent }]
            },


            {
                path: 'refund-request', component: ApplicantComponent,
                children: [{ path: '', component: RefundRequestComponent }]
            },

            {
                path: 'payment/:AppNo/:Mode', component: ApplicantComponent,
                children: [{ path: '', component: PaymentComponent }]
            },
            {
                path: 'appstatus', component: ApplicantComponent,
                children: [{ path: '', component: StatusviewComponent },
                { path: 'status', component: AppstatusComponent },
                { path: 'instapay/:APP_Id/:APP_No/:APP_Status', component: ApplicationinstallmentpayComponent },
                { path: 'cancellation/:APP_Id/:APP_Status', component: ApplicationcancellationComponent },
                { path: 'requestrefund/:App_Id/:APP_Status', component: ApplicationrefundComponent },
                { path: 'application-form/:NO_Id/:PD_Id/:appmode', component: ApplicationformComponent },
                { path: 'applicantview/:APP_Id/:NO_Id/:mode', component: ApplicationViewComponent }
                ]
            },
            {
                path: 'transactiondetails', component: ApplicantComponent,
                children: [{ path: '', component: TransactionDetailsComponent }]
            },
            {
                path: 'applicationquery', component: ApplicantComponent,
                children: [
                    { path: '', component: ApplicantQueryComponent }
                    //{ path: '', component: ApplicationstatusComponent }
                ]
            },

            {
                path: 'directallotment', component: ApplicantComponent,
                children: [
                    { path: '', component: DirectAllocationComponent }
                    //{ path: '', component: ApplicationstatusComponent }
                ]
            },


            //End
            {
                path: 'paymentconfig', component: AllocationComponent,
                children: [
                    { path: '', component: PaymentConfigViewComponent },
                    { path: 'payment-config-form', component: PaymentConfigComponent },
                    { path: 'payment-config-form/:PC_Id/:mode', component: PaymentConfigComponent }
                ]
            },

            {
                path: 'refund', component: AllocationComponent,
                children: [{ path: '', component: RefundComponent }]
            },
            {
                path: 'refundlist', component: AllocationComponent,
                children: [{ path: '', component: RefundlistComponent }]
            },

            {
                path: 'applicationList', component: AllocationComponent,
                children: [{ path: '', component: ApplicationlistComponent }
                ]
            },
            {
                path: 'planning', component: PlanningComponent,
                children: [{ path: '', component: ProjectListComponent },
                { path: 'planning-form', component: ProjectFormComponent },
                { path: 'planning-form/:PD_Id/:mode', component: ProjectFormComponent }
                ]
            },
            {
                path: 'consultant', component: PlanningComponent,
                children: [{ path: '', component: ConsultantListComponent },
                { path: 'consultant-form', component: ConsultantFromComponent },
                { path: 'consultant-form/:CD_Id/:mode', component: ConsultantFromComponent }
                ]
            },

            {
                path: 'landrecord', component: PlanningComponent,
                children: [{ path: '', component: LandrecordlistComponent },
                // { path: 'Landform/:LR_Id/:PD_Id/:mode', component: LandrecordlistComponent },
                { path: 'land-form', component: LandrecordformComponent }
                ]
            },

            {
                path: 'statutory', component: PlanningComponent,
                children: [{ path: '', component: StatutoryClearancesGridComponent },
                { path: 'statutory-form', component: StatutoryClearancesFormComponent },
                { path: 'statutory-form/:PD_Id/:mode', component: StatutoryClearancesFormComponent }
                ]
            },



            {
                path: 'drawingbykhb', component: PlanningComponent,
                children: [{ path: '', component: KhbDrawingGridComponent },
                { path: 'drawingbykhb-form', component: KhbDrawingFormComponent },
                { path: 'drawingbykhb-form/:PD_Id/:mode', component: KhbDrawingFormComponent }
                ]
            },

            {
                path: 'approveddrawing', component: PlanningComponent,
                children: [{ path: '', component: ApprovedDrawingGridComponent },
                { path: 'approveddrawing-form', component: ApprovedDrawingFormComponent },
                { path: 'approveddrawing-form/:PD_Id/:mode', component: ApprovedDrawingFormComponent }
                ]
            },


            {
                path: 'builtdrawing', component: PlanningComponent,
                children: [{ path: '', component: BuiltDrawingGridComponent },
                { path: 'builtdrawing-form', component: BuiltDrawingFormComponent },
                { path: 'builtdrawing-form/:PD_Id/:mode', component: BuiltDrawingFormComponent }

                ]
            },

            {
                path: 'reviseddrawing', component: PlanningComponent,
                children: [{ path: '', component: RevisedDrawingGridComponent },
                { path: 'reviseddrawing-form', component: RevisedDrawingFormComponent },
                { path: 'reviseddrawing-form/:PD_Id/:mode', component: RevisedDrawingFormComponent }
                ]
            },
            {
                path: 'property-register', component: PlanningComponent,
                children: [{ path: '', component: PropertiesregisterListComponent },
                { path: 'propertiesregister-form', component: PropertiesregisterFormComponent }
                ]
            },

            {
                path: 'revised-property', component: PlanningComponent,
                children: [{ path: '', component: RevisedpropertyregisterGridComponent },
                { path: 'revised-property-form/:PR_Id/:mode', component: RevisedpropertyregisterFormComponent },
                { path: 'pre-allotment-prop/:mode', component: PrAllotmentGridComponent },
                { path: 'pre-allotmentform-prop/:PD_Id/:mode', component: PrAllotmentFormComponent },
                { path: 'pre-allotmentformnotsent-prop/:PD_Id/:mode', component: PrAllotmentNotsentComponent },
                { path: 'pre-allotmentall-prop/:PD_Id/:mode', component: PropertyPlanAlllistComponent }
                ]
            },

            {
                path: 'project-received-lp', component: PlanningComponent,
                children: [{ path: '', component: ProjectReceivedLpGridComponent },
                    // { path: 'propertiesregister-form', component: PropertiesregisterFormComponent }
                ]
            },
            {
                path: 'project-phase', component: PlanningComponent,
                children: [{ path: '', component: ProjectPhaseGridComponent },
                { path: 'project-phase-form', component: ProjectPhaseFormComponent },
                { path: 'project-phase-form/:PD_Id/:PP_Id/:mode', component: ProjectPhaseFormComponent }
                ]
            },

            {
                path: 'landprocurement', component: LandprocurementComponent,
                children: [{ path: '', component: ProposalGridComponent },
                { path: 'proposal-form', component: ProposalFormComponent },
                { path: 'proposal-form/:PR_Id/:mode', component: ProposalFormComponent }
                ]
            },

            {
                path: 'Land-planning', component: LandprocurementComponent,
                children: [{ path: '', component: LandProjectGridComponent },
                { path: 'planning-form', component: LandProjectFormComponent },
                { path: 'planning-form/:PD_Id/:mode', component: LandProjectFormComponent }
                ]
            },

            {
                path: 'viabilityreport', component: LandprocurementComponent,
                children: [{ path: '', component: ViabilityGridComponent },
                { path: 'viabilityform', component: ViabilityFormComponent },
                { path: 'viabilityform/:VR_Id/:mode', component: ViabilityFormComponent }
                ]
            },
            {
                path: 'inspectionreport', component: LandprocurementComponent,
                children: [{ path: '', component: InspectionGridComponent },
                { path: 'inspection-form', component: InspectionFormComponent },
                { path: 'inspection-form/:IR_Id/:mode', component: InspectionFormComponent }
                ]
            },
            {
                path: 'ratefixation', component: LandprocurementComponent,
                children: [{ path: '', component: RateGridComponent },
                { path: 'rate-form', component: RateFormComponent },
                { path: 'rate-form/:RF_Id_PK/:mode', component: RateFormComponent }
                ]
            },

            {
                path: 'objectionnotification', component: LandprocurementComponent,
                children: [{ path: '', component: OnGridComponent },
                { path: 'ON-form', component: OnFormComponent },
                { path: 'ON-form/:ON_Id/:mode', component: OnFormComponent }
                ]
            },

            {
                path: 'landdetails', component: LandprocurementComponent,
                children: [
                    { path: '', component: LandProjectDetailsComponent },
                    { path: 'landdetails-grid/:PD_Id/:PR_Id_PK', component: LanddetailsGridComponent },
                    { path: 'landdetails-form', component: LanddetailsFormComponent },
                    { path: 'landdetails-form/:LOD_Id_PK/:mode', component: LanddetailsFormComponent }
                ]
            },


            {
                path: 'landrecdetails', component: LandprocurementComponent,
                children: [{ path: '', component: LandrecFormComponent },
                    // { path: 'landrec-form', component: LandrecFormComponent }
                ]
            },

            {
                path: 'landpayment', component: LandprocurementComponent,
                children: [{ path: '', component: LandpaymentGridComponent },
                { path: 'landpayment-form', component: LandpaymentFormComponent },
                { path: 'landpayment-form/:PD_Id', component: LandpaymentFormComponent }
                ]
            },

            // {
            //     path: 'landpurchase', component: LandprocurementComponent,
            //     children: [{ path: '', component: LandpurchaseGridComponent },
            //     { path: 'landpurchase-form', component: LandpurchaseFormComponent },
            //     { path: 'landpurchase-form/:LP_Id/:mode', component: LandpurchaseFormComponent }
            //     ]
            // },      

            {
                path: 'landpurchase', component: LandprocurementComponent,
                children: [{ path: '', component: LandpurchaseGridComponent },
                {
                    path: 'land-pur-agreement', component: LandpurchaseFormComponent,
                    children: [
                        { path: '', component: LpAgreementGridComponent },
                        { path: 'land-pur-agreement-form', component: LpAgreementFormComponent },
                        { path: 'land-pur-agreement-form/:LP_Id/:mode', component: LpAgreementFormComponent },
                        { path: 'land-pur-purchase', component: LpPurchaseGridComponent },
                        { path: 'land-pur-purchase/land-pur-purchase-form', component: LpPurchaseFormComponent },
                        { path: 'land-pur-purchase/land-pur-purchase-form/:LP_Id/:mode', component: LpPurchaseFormComponent },
                        { path: 'land-pur-payment', component: LpPaymentGridComponent },
                        { path: 'land-pur-payment/land-pur-payment-form', component: LpPaymentFormComponent },
                        { path: 'land-pur-profession', component: LpProfessionGridComponent },
                        { path: 'land-pur-profession/land-pur-profession-form', component: LpProfessionFormComponent },
                        { path: 'land-pur-profession/land-pur-profession-form/:LP_Id/:mode', component: LpProfessionFormComponent },
                    ]
                },
                    // { path: 'landpurchase-form/:LP_Id/:mode', component: LandpurchaseFormComponent }
                ]
            },

            {
                path: 'joint-venture', component: LandprocurementComponent,
                children: [
                    {
                        path: '', component: JointVentureComponent,
                        children: [
                            { path: '', component: JvAgreementGridComponent },
                            { path: 'jv-agreement-form', component: JvAgreementFormComponent },
                            { path: 'jv-agreement-form/:LP_Id/:mode', component: JvAgreementFormComponent },
                            { path: 'jv-exceptence', component: JvExceptenceGridComponent },
                            { path: 'jv-exceptence-form', component: JvExceptenceFormComponent },
                            { path: 'jv-exceptence-form/:LP_Id/:mode', component: JvExceptenceFormComponent },
                            { path: 'jv-possession', component: JvPossessionGridComponent },
                            { path: 'jv-possession-form', component: JvPossessionFormComponent },
                            { path: 'jv-possession-form/:LP_Id/:mode', component: JvPossessionFormComponent },

                        ]
                    }
                ]
            },

            {
                path: 'landacquisition', component: LandprocurementComponent,
                children: [{ path: '', component: LandacquisitionGridComponent },
                { path: 'landacquisition-form', component: LandacquisitionFormComponent },
                { path: 'landacquisition-form/:LA_Id/:mode', component: LandacquisitionFormComponent }
                ]
            },

            {
                path: 'land-procurement-details', component: LandprocurementComponent,
                children: [
                    {
                        path: '', component: LandacquisitionGridComponent,
                        // children:[
                        //     { path: '', component:  },
                        //     { path: 'landacquisition-form', component: LandacquisitionFormComponent },
                        //     { path: 'landacquisition-form/:LA_Id/:mode', component: LandacquisitionFormComponent },
                        //     { path: 'landpurchase', component: LandpurchaseGridComponent },
                        //     { path: 'landpurchase-form', component: LandpurchaseFormComponent },
                        //     { path: 'landpurchase-form/:LP_Id/:mode', component: LandpurchaseFormComponent },

                        // ]

                    },
                    {
                        path: 'landacquisition-form', component: LandacquisitionFormComponent
                    },
                    {
                        path: 'landacquisition-form/:LA_Id/:mode/:type', component: LandacquisitionFormComponent
                    },
                ]
            },

            {
                path: 'land-town-planning', component: LandprocurementComponent,
                children: [
                    { path: '', component: LandTownPlanningGridComponent },
                    { path: 'land-town-planning-form', component: LandTownPlanningFormComponent },
                    { path: 'land-town-planning-form/:PD_Id/:LTP_Id/:mode', component: LandTownPlanningFormComponent }
                ]
            },

            {
                path: 'boardmeeting', component: LandprocurementComponent,
                children: [{ path: '', component: BoardmeetinggridComponent },
                { path: 'boardmeeting-form', component: BoardmeetingComponent },
                { path: 'boardmeeting-form/:BM_Id/:mode', component: BoardmeetingComponent }
                ]
            },

            {
                path: 'registerddoc', component: LandprocurementComponent,
                children: [{ path: '', component: RegisterdocGridComponent },
                { path: 'registerddoc-form', component: RegisterdocFormComponent }
                ]
            },
            {
                path: 'eeapproval', component: LandprocurementComponent,
                children: [{ path: '', component: ApprovalGridComponent },
                { path: 'eeapproval-form', component: ApprovalFormComponent }
                ]
            },




            {
                path: 'demandsurvey', component: LandprocurementComponent,
                children: [{ path: '', component: DemandsurveyGridComponent },
                { path: 'demandsurvey-form', component: DemandsurveyFormComponent }
                ]
            },
            {
                path: 'employedadvocates', component: LegalComponent,
                children: [{ path: '', component: AdvocatesGridComponent },
                { path: 'employedadvocates-form', component: AdvocatesFormComponent }
                ]
            },

            {
                path: 'caseregistration', component: LegalComponent,
                children: [{ path: '', component: CrViewComponent },
                { path: 'case-reg-form', component: CrFormComponent },
                { path: 'case-reg-form/:CaseId/:mode', component: CrFormComponent }
                ]
            },

            {
                path: 'caseproceeding', component: LegalComponent,
                children: [{ path: '', component: CpCrViewComponent },
                { path: 'case-pro-form/:Id/:mode/:CaseProcId', component: CpFormComponent },
                { path: 'case-pro-form', component: CpFormComponent },
                { path: 'cp-view/:CaseId', component: CpViewComponent }
                ]
            },
            {

                path: 'advocate-pay', component: LegalComponent,
                children: [{ path: '', component: AdvPayGridComponent },
                { path: ':AdvId/:CaseId', component: AdvPayGridComponent },
                { path: 'advocate-pay-form/:AdvId/:CaseId/:AP_Id/:mode', component: AdvPayFormComponent },
                { path: 'advocate-pay-form', component: AdvPayFormComponent }
                    // { path: 'advocate-pay-form/:AdvId/:CaseId/:AP_Id/:mode', component: AdvPayFormComponent }
                ]
            },

            {
                path: 'adv-change', component: LegalComponent,
                children: [{ path: '', component: CavGridComponent },
                { path: 'adv-change-form', component: CavFormComponent }
                ]
            },
            {
                path: 'filemovement', component: LegalComponent,
                children: [{ path: '', component: FmGridComponent },
                { path: 'filemovement-form', component: FmFormComponent },
                { path: 'filemovement-form/:FM_Id/:mode', component: FmFormComponent }

                ]
            },
            {
                path: 'Query', component: LegalComponent,
                children: [{ path: '', component: QueryComponent },
                { path: 'case/:CaseId', component: QueryComponent }
                ]
            },

            {
                path: 'BillsToFinance', component: LegalComponent,
                children: [{ path: '', component: BillsToFinanceComponent }
                ]
            },

            {
                path: 'casetype', component: MasterComponent,
                children: [{ path: '', component: CasetypeGridComponent },
                { path: 'casetype-form', component: CasetypeFormComponent },
                { path: 'casetype-form/:CaseType_Id/:mode', component: CasetypeFormComponent }
                ]
            },
            {
                path: 'tender', component: TechnicalComponent,
                children: [{ path: '', component: TenderGridComponent },
                { path: 'tender-form', component: TenderFormComponent },
                { path: 'tender-form/:Tender_id/:mode', component: TenderFormComponent }


                
                ]
            },
            {
                path: 'staffmob', component: TechnicalComponent,
                children: [{ path: '', component: StaffGridComponent },
                { path: 'staff-form', component: StaffFormComponent },
                { path: 'staff-form/:staff_mob_demob_id/:mode', component: StaffFormComponent }
                ]
            },
            {
                path: 'equipmob', component: TechnicalComponent,
                children: [{ path: '', component: EquipmentGridComponent },
                { path: 'equipment-form', component: EquipmentFormComponent },
                { path: 'equipment-form/:equipmobdemob_id/:mode', component: EquipmentFormComponent }
                ]
            },
            {
                path: 'baseline', component: TechnicalComponent,
                children: [{ path: '', component: BoqGridComponent },
                { path: 'baselineboq-form', component: BoqFormComponent },
                { path: 'baselineboq-form/:Baseline_BOQ_Id/:mode', component: BoqFormComponent }
                ]
            },
            {
                path: 'projactivity', component: TechnicalComponent,
                children: [{ path: '', component: ActivityGridComponent },
                { path: 'activity-form', component: ActivityFormComponent },
                { path: 'activity-form/:ProjectActivityJob_id/:mode', component: ActivityFormComponent }
                ]
            },
            {
                path: 'jobgroup', component: TechnicalComponent,
                children: [{ path: '', component: JobgroupViewComponent },
                { path: 'jobgroup-form', component: JobgroupFormComponent },
                { path: 'jobgroup-form/:jobgroup_id/:mode', component: JobgroupFormComponent }
                ]
            },
            {
                path: 'Jobs', component: TechnicalComponent,
                children: [{ path: '', component: JobsViewComponent },
                { path: 'jobs-form', component: JobsFormComponent },
                { path: 'jobs-form/:Job_id/:mode', component: JobsFormComponent }
                ]
            },
            {
                path: 'structures', component: TechnicalComponent,
                children: [{ path: '', component: StructuresViewComponent },
                { path: 'structures-form', component: StructuresFormComponent },
                { path: 'structures-form/:Structure_id/:mode', component: StructuresFormComponent }
                ]
            },
            {
                path: 'structuresplanning', component: TechnicalComponent,
                children: [{ path: '', component: StructuresplanningGridComponent },
                { path: 'structuresplanning-form', component: StructuresplanningFormComponent },
                { path: 'structuresplanning-form/:StructPlan_id/:mode', component: StructuresplanningFormComponent }
                ]
            },
            {
                path: 'boqitem', component: TechnicalComponent,
                children: [{ path: '', component: BoqitemGridComponent },
                { path: 'boqitem-form', component: BoqitemFormComponent },
                { path: 'boqitem-form/:boq_item_id/:mode', component: BoqitemFormComponent }
                ]
            },
            {
                path: 'milestone', component: TechnicalComponent,
                children: [{ path: '', component: MilestoneGridComponent },
                { path: 'milestone-form', component: MilestoneFormComponent },
                { path: 'milestone-form/:phase_milestone_id/:mode', component: MilestoneFormComponent }
                ]
            },
            {
                path: 'schedule', component: TechnicalComponent,
                children: [{ path: '', component: PhasescheduleGridComponent },
                { path: 'schedule-form', component: PhasescheduleFormComponent },
                { path: 'schedule-form/:PhaseSchedule_id/:mode', component: PhasescheduleFormComponent }
                ]
            },
            {
                path: 'contractor', component: TechnicalComponent,
                children: [{ path: '', component: ContractorGridComponent },
                { path: 'contractor-form', component: ContractorFormComponent },
                { path: 'contractor-form/:Contractor_id/:mode', component: ContractorFormComponent }
                ]
            }
            ,
            {
                path: 'contractordoc', component: TechnicalComponent,
                children: [{ path: '', component: ContractordocGridComponent },
                { path: 'contractordoc-form', component: ContractordocFormComponent },
                { path: 'contractordoc-form/:ContractorDoc_id/:mode', component: ContractordocFormComponent }
                ]
            },
            {
                path: 'contractordoctype', component: TechnicalComponent,
                children: [{ path: '', component: DocTypeGridComponent },
                { path: 'contractordoctype-form', component: DocTypeFormComponent }
                ]
            },
            {
                path: 'projectencumbrancetype', component: TechnicalComponent,
                children: [{ path: '', component: EncumbrancesTypeGridComponent },
                { path: 'projectencumbrancetype-form', component: EncumbrancesTypeFormComponent },
                { path: 'projectencumbrancetype-form/:encumb_id/:mode', component: EncumbrancesTypeFormComponent }
                ]
            },
            {
                path: 'projectencumbrance', component: TechnicalComponent,
                children: [{ path: '', component: EncumbrancesGridComponent },
                { path: 'projectencumbrance-form', component: EncumbrancesFormComponent },
                { path: 'projectencumbrance-form/:Projencumb_id/:mode', component: EncumbrancesFormComponent }
                ]
            },
            {
                path: 'encumbrancequantum', component: TechnicalComponent,
                children: [{ path: '', component: QuantumGridComponent },
                { path: 'encumbrancequantum-form', component: QuantumFormComponent },
                { path: 'encumbrancequantum-form/:EncumbranceQuantum_id/:mode', component: QuantumFormComponent }
                ]
            },
            {
                path: 'designissuetype', component: TechnicalComponent,
                children: [{ path: '', component: DesignIssueTypeGridComponent },
                { path: 'designissuetype-form', component: DesignIssueTypeFormComponent },
                { path: 'designissuetype-form/:desisstype_id/:mode', component: DesignIssueTypeFormComponent }
                ]
            },
            {
                path: 'designissue', component: TechnicalComponent,
                children: [{ path: '', component: DesignIssueGridComponent },
                { path: 'designissue-form', component: DesignIssueFormComponent },
                { path: 'designissue-form/:desiss_id/:mode', component: DesignIssueFormComponent }
                ]
            },
            {
                path: 'scheduleextension', component: TechnicalComponent,
                children: [{ path: '', component: ScheduleExtensionGridComponent },
                { path: 'scheduleextension-form', component: ScheduleExtensionFormComponent },
                { path: 'scheduleextension-form/:ContScheduleExt_id/:mode', component: ScheduleExtensionFormComponent }
                ]
            },
            {
                path: 'pesc-type', component: TechnicalComponent,
                children: [{ path: '', component: PescTypeGridComponent },
                { path: 'pesc-type-form', component: PescTypeFormComponent }
                ]
            },
            {
                path: 'pesc', component: TechnicalComponent,
                children: [{ path: '', component: PescGridComponent },
                { path: 'pesc-form', component: PescFormComponent }
                ]
            },
            {
                path: 'progressphoto', component: TechnicalComponent,
                children: [{ path: '', component: ProjectProgressGridComponent },
                { path: 'progressphoto-form', component: ProjectProgressFormComponent }
                ]
            },
            {
                path: 'qc-type', component: TechnicalComponent,
                children: [{ path: '', component: QcTypeGridComponent },
                { path: 'qc-type-form', component: QcTypeFormComponent }
                ]
            },
            {
                path: 'qc', component: TechnicalComponent,
                children: [{ path: '', component: QcGridComponent },
                { path: 'qc-form', component: QcFormComponent }
                ]
            },
            //Technical Section Additional Modules Starts
            {
                path: 'issueworkorder', component: TechnicalComponent,
                children: [{ path: '', component: IssueorderFormComponent }
                ]
            },
            {
                path: 'globaldata', component: TechnicalComponent,
                children: [{ path: '', component: GlobalDataFormComponent }
                ]
            },
            {
                path: 'workordermetrics', component: TechnicalComponent,
                children: [
                    { path: '', component: MetricsGridComponent },
                    { path: 'workordermetrics-form', component: MetricsFormComponent }

                ]
            },
            {
                path: 'dashboardtech', component: TechnicalComponent,
                children: [{ path: '', component: DashboardTechComponent }
                ]
            },
            {
                path: 'workprogress', component: TechnicalComponent,
                children: [
                    {
                        path: '', component: ProjectProgressComponent,
                        children: [
                            { path: '', component: ScheduleFormComponent },
                            { path: 'workprogress', component: WorkprogressFormComponent },
                            { path: 'photo', component: ProjectProgressGridComponent },
                            { path: 'progressphoto-form', component: ProjectProgressFormComponent }
                        ]
                    }
                ]
            },
            {
                path: 'billing', component: TechnicalComponent,
                children: [
                    {
                        path: '', component: BillingComponent,
                        children: [
                            { path: '', component: RaBillFormComponent },
                            { path: 'tenderbill', component: TenderBillFormComponent },
                            { path: 'billstatus', component: BillStatusComponent },
                            { path: 'billpayments', component: BillPaymentsFormComponent },
                            { path: 'billsummary', component: BillSummaryComponent },
                            { path: 'billpaybills', component: BillPaybillsFormComponent },
                            { path: 'workslip', component: WorkslipStatementComponent }
                        ]
                    }
                ]
            },
            //Technical Section Additional Modules Ends 

            {
                path: 'godown', component: GodownComponent,
                children: [
                    {
                        path: '', component: AddBundleComponent,
                    }
                ]
            },

            {
                path: 'returnRequest', component: GodownComponent,
                children: [{ path: '', component: AppRetRequestComponent },
                ]
            },

            {
                path: 'godownQuery', component: GodownComponent,
                children: [{ path: '', component: GodownQueryComponent },
                ]
            },

            {
                path: 'godownReports', component: GodownComponent,
                children: [{ path: '', component: GodownReportsComponent },
                ]
            },

            {
                path: 'reports',
                component: ReportsComponent
            },
            {
                path: 'report1',
                component: DqVacantPropertyComponent
            },
            {
                path: 'report2',
                component: ClearVacantPropertyComponent
            },
            {
                path: 'report3',
                component: CornerVacantPropertyComponent
            },
            {
                path: 'report4',
                component: DistrictwiseVacantPropertyComponent
            }, {
                path: 'report5',
                component: VacantCommercialPropertyComponent
            }, {
                path: 'report16',
                component: AvailBlockedInterDqCornerComponent
            }, {
                path: 'report17',
                component: IntermediateAvailableSitehouseflatsComponent
            }, {
                path: 'report18',
                component: IntermediateBlockedSitehouseflatsComponent
            },
            {
                path: 'CalenderMaster',
                component: IntermediateBlockedSitehouseflatsComponent
            },

            //Recovery Routes Starts
            {
                path: 'buildingdetails', component: RecoveryComponent,
                children: [{ path: '', component: BuildingGridComponent },
                { path: 'buildingdetails-form', component: BuildingFormComponent }
                ]
            },
            {
                path: 'rec_ratefixation', component: RecoveryComponent,
                children: [{ path: '', component: RateFixationGridComponent },
                { path: 'rec_ratefixation-form', component: RateFixationFormComponent }
                ]
            },
            {
                path: 'agreements', component: RecoveryComponent,
                children: [
                    {
                        path: '', component: AgreementsAppComponent,
                        children: [
                            { path: '', component: AgreementsGridComponent },
                            { path: 'agreements-form', component: AgreementsFormComponent },
                            { path: 'agreements-approval', component: AgreementAppGridComponent },
                            { path: 'agreements-app-form', component: AgreementAppFormComponent },
                            { path: 'agreements-form/:REQP_ID/:mode', component: AgreementsFormComponent },
                            // { path: 'agreements-form/:REQP_ID/:mode/:Applant_Type', component: AgreementsFormComponent },
                            { path: 'agreements-form/:REQP_ID/:BackId/:mode', component: AgreementsFormComponent },
                        ]
                    },

                ]
            },
            {
                path: 'customer-master', component: RecoveryComponent,
                children: [{ path: '', component: CustomerGridComponent },
                { path: 'customer-master-form', component: CustomerFormComponent },
                { path: 'customer-master-form/:CUST_ID/:mode', component: CustomerFormComponent }
                ]
            },
            {
                path: 'request-property', component: RecoveryComponent,
                children: [
                    // { path: '', component: RequestPropertyGridComponent },
                    // { path: 'request-property-form', component: RequestPropertyFormComponent }
                    {
                        path: '', component: RequestPropertiesComponent,
                        children: [
                            { path: '', component: RequestPropertyGridComponent },
                            { path: 'request-property-form', component: RequestPropertyFormComponent },
                            { path: 'request-property-approval', component: RequestPropertyAppGridComponent },
                            { path: 'request-property-approval-form', component: RequestPropertyAppFormComponent },
                            { path: 'request-property-form/:REQP_ID/:mode', component: RequestPropertyFormComponent },
                            { path: 'request-property-form/:REQP_ID/:BId/:mode/:CUST_ID', component: RequestPropertyFormComponent },
                            { path: 'request-property-form/:REQP_ID/:REQP_APP_TYPE/:mode', component: RequestPropertyFormComponent }

                        ]
                    },

                ]
            },
            {
                path: 'paymentreceipt', component: RecoveryComponent,
                children: [
                    {
                        path: '', component: PaymentReceiptApprovalComponent,
                        children: [
                            { path: '', component: PaymentReceiptsGridComponent },
                            { path: 'payment-receipts-form', component: PaymentReceiptsFormComponent },
                            { path: 'payment-receipt-approval', component: PaymentReceiptAppGirdComponent },
                            { path: 'payment-receipt-app-form', component: PaymentReceiptAppFormComponent },
                            { path: 'payment-receipts-form/:Payment_Receipt_Id/:mode', component: PaymentReceiptsFormComponent },
                            { path: 'payment-receipts-form/:Payment_Receipt_Id/:BackId/:mode', component: PaymentReceiptsFormComponent }
                        ]
                    },

                ]
            },
            {
                path: 'paymentchallan', component: RecoveryComponent,
                children: [
                    {
                        path: '', component: PaymentChallApprovalComponent,
                        children: [
                            { path: '', component: PaymentChallanGridComponent },
                            { path: 'payment-challan-form', component: PaymentChallanFormComponent },
                            { path: 'payment-chall-app-grid', component: PaymentChallAppGridComponent },
                            { path: 'payment-chall-app-form', component: PaymentChallAppFormComponent },
                            { path: 'payment-challan-form/:Payment_Id/:mode', component: PaymentChallanFormComponent },
                            { path: 'payment-challan-form/:Payment_Id/:BackId/:mode', component: PaymentChallanFormComponent }
                        ]
                    },
                ]
            },
            {
                path: 'Renewals', component: RecoveryComponent,
                children: [{ path: '', component: RenewalsGridComponent },
                { path: 'Renewals-form', component: RenewalsFormComponent },
                { path: 'Renewals/:BackId/:mode', component: AgreementsFormComponent }
                ]
            },
            {
                path: 'recovery-reports', component: RecoveryComponent,
                children: [{ path: '', component: RecoveryReportGridComponent },
                    // { path: 'recovery-reports-form', component: RecoveryReportFormComponent }
                ]
            },
            {
                path: 'block', component: RecoveryComponent,
                children: [{ path: '', component: BlockGridComponent },
                { path: 'block-form', component: BlockFormComponent }
                ]
            },
            {
                path: 'property-recovery', component: RecoveryComponent,
                children: [
                    { path: '', component: PropertyGridComponent },
                    { path: 'property-recovery-form', component: PropertyFormComponent }
                ]
            },


            // HRMS Routes start
            {
                path: 'caste', component: MasterComponent,
                children: [{ path: '', component: CasteGridComponent },
                { path: 'caste-form', component: CasteFormComponent },
                { path: 'caste-form/:Caste_Id/:mode', component: CasteFormComponent },
                ]
            },
            {
                path: 'designation', component: MasterComponent,
                children: [{ path: '', component: DesignationGridComponent },
                { path: 'designation-form', component: DesignationFormComponent },
                { path: 'designation-form/:Dsc_Id/:mode', component: DesignationFormComponent }
                ]
            },

            {
                path: 'religion', component: MasterComponent,
                children: [{ path: '', component: ReligionGridComponent },
                { path: 'religion-form', component: ReligionFormComponent },
                { path: 'religion-form/:Rlg_Id/:mode', component: ReligionFormComponent }
                ]

            },

            {
                path: 're/:Rlg_Id/:mode', component: ReligionFormComponent
            },

            {
                path: 'scales', component: MasterComponent,
                children: [{ path: '', component: ScalesGridComponent },
                { path: 'scales-form', component: ScalesFormComponent },
                { path: 'scales-form/:scale_id/:mode', component: ScalesFormComponent }
                ]
            },
            {
                path: 'salary', component: MasterComponent,
                children: [{ path: '', component: SalaryGridComponent },
                { path: 'salary-form', component: SalaryFormComponent }
                ]
            },
            {
                path: 'userprofile', component: MasterComponent,
                children: [{ path: '', component: UserprofileGridComponent },
                { path: 'userprofile-form', component: UserprofileFormComponent }
                ]
            },
            {
                path: 'holidaycalendar', component: MasterComponent,
                children: [{ path: '', component: HolidaycalendarGridComponent },
                { path: 'holidaycalendar-form', component: HolidaycalendarFormComponent },
                { path: 'holidaycalendar-form/:hld_id/:mode', component: HolidaycalendarFormComponent }
                ]
            },
            {
                path: 'leaves', component: MasterComponent,
                children: [{ path: '', component: LeavesGridComponent },
                { path: 'leaves-form', component: LeavesFormComponent },
                { path: 'leaves-form/:Leave_id/:mode', component: LeavesFormComponent }
                ]
            },

            {
                path: 'masters', component: HrmsComponent,
                children: [
                    {
                        path: '', component: MasterDisplayComponent,
                        children: [
                            { path: '', component: ReligionGridComponent },
                            { path: 'religion-form', component: ReligionFormComponent },
                            { path: 'caste', component: CasteGridComponent },
                            { path: 'caste/caste-form', component: CasteFormComponent },
                            { path: 'designation', component: DesignationGridComponent },
                            { path: 'designation/designation-form', component: DesignationFormComponent },
                            { path: 'scales', component: ScalesGridComponent },
                            { path: 'scales/scales-form', component: ScalesFormComponent },
                            { path: 'leaves', component: LeavesGridComponent },
                            { path: 'leaves/leaves-form', component: LeavesFormComponent },
                            { path: 'salary', component: SalaryGridComponent },
                            { path: 'salary/salary-form', component: SalaryFormComponent },
                            { path: 'holidaycalendar', component: HolidaycalendarGridComponent },
                            { path: 'holidaycalendar/holidaycalendar-form', component: HolidaycalendarFormComponent },
                            { path: 'holidaycalendar/holidaycalendar-form/:hld_id/:mode', component: HolidaycalendarFormComponent },
                            { path: 'hospital', component: HospitalGridComponent },
                            { path: 'hospital/hospital-form', component: HospitalFormComponent },
                            { path: 'master-calendar', component: MasterCalendarGridComponent },
                            { path: 'master-calendar/master-calendar-form', component: MasterCalendarFormComponent },
                            { path: 'master-calendar/master-calendar-form/:calendar_id/:mode', component: MasterCalendarFormComponent },
                        ]
                    }
                ]
            },


            // 
            {
                path: 'serviceregister', component: HrmsComponent,
                children: [
                    {
                        path: '', component: ServiceregisterComponent,
                        children: [
                            { path: '', component: EmpBasicDetailGridComponent },
                            { path: 'empbasicdetails-form', component: EmpBasicDetailFormComponent },

                            { path: 'empbasicdetails-form/:id/:mode', component: EmpBasicDetailFormComponent },
                            { path: 'dependentdetails', component: DependentGridComponent },
                            { path: 'dependentdetails-form', component: DependentFormComponent },


                            { path: 'service-reg-view', component: ServiceRegViewFormComponent },

                            //Meghana
                            { path: 'dependentdetails-form/:id/:mode/:empId', component: DependentFormComponent },
                            { path: 'qualification', component: QualificationInputGridComponent },
                            { path: 'qualification-form', component: QualificationInputFormComponent },

                            { path: 'qualification-form/:id/:mode/:empId', component: QualificationInputFormComponent },
                            { path: 'leavedetails', component: LeaveDetailsGridComponent },
                            { path: 'leavedetails-form', component: LeaveDetailsFormComponent },
                            { path: 'leavedetails-form/:id/:mode/:empId', component: LeaveDetailsFormComponent },
                            { path: 'bankdetails', component: BankDetailsGridComponent },
                            { path: 'bankdetails-form', component: BankDetailsFormComponent },
                            //Meghana
                            { path: 'bankdetails-form/:id/:mode/:empId', component: BankDetailsFormComponent },
                            { path: 'address-details', component: AddressDetailsComponent },
                            { path: 'address-details-form', component: AddressDetailsFormComponent },

                            { path: 'address-details-form/:id/:mode/:empId', component: AddressDetailsFormComponent },
                            { path: 'experiencedetails', component: ExperiencedetailsGridComponent },
                            { path: 'experiencedetails-form', component: ExperiencedetailsFormComponent },
                            { path: 'experiencedetails-form/:id/:mode/:empId', component: ExperiencedetailsFormComponent },
                            { path: 'policeverification', component: PoliceVerificationGridComponent },
                            { path: 'policeverification-form', component: PoliceVerificationComponent },

                            { path: 'leave-bal-details', component: LeaveBalDetGridComponent },
                            { path: 'leave-bal-details-form', component: LeaveBalDetFormComponent },
                            { path: 'leave-bal-details-form/:empId', component: LeaveBalDetFormComponent },

                            //Meghana
                            { path: 'policeverification-form/:id/:mode', component: PoliceVerificationComponent },
                            { path: 'policeverification-form/:id/:mode/:empId', component: PoliceVerificationComponent },


                        ]
                    }
                ]
            },




            {
                path: 'payroll', component: HrmsComponent,
                children: [
                    {
                        path: '', component: PayrollComponent,
                        children: [
                            {
                                path: '', component: PayrollMastersComponent,
                                children: [
                                    { path: '', component: AllowanceCodeGridComponent },
                                    { path: 'allowance-code', component: AllowanceCodeComponent },
                                    { path: 'allowance-code/:id/:mode', component: AllowanceCodeComponent },
                                    { path: 'deduction-code-grid', component: DeductionCodeGridComponent },
                                    { path: 'deduction-code-grid/deduction-code', component: DeductionCodeComponent },
                                    { path: 'deduction-code-grid/deduction-code/:id/:mode', component: DeductionCodeComponent },
                                    { path: 'formula', component: FormulaGridComponent },
                                    { path: 'formula/formula-form', component: FormulaFormComponent },
                                    { path: 'formula/formula-form/:id/:mode', component: FormulaFormComponent }
                                ]
                            },
                            {
                                path: 'payroll-compliance', component: OrganisationProfileComponent,
                                children: [
                                    { path: '', component: IncomeTaxGridComponent },
                                    { path: ':id/:mode', component: IncomeTaxGridComponent },
                                    { path: 'professional-tax', component: ProfessionalTaxGridComponent },
                                    { path: 'professional-tax/professional-tax-form', component: ProfessionalTaxFormComponent },
                                    { path: 'income-tax/income-tax-form', component: IncomeTaxFormComponent },
                                    { path: 'control-data', component: ControlDataComponent },
                                    { path: 'pay-monthly', component: PayMonthlyGridComponent },
                                    { path: 'pay-monthly/pay-monthly-view', component: PayMonthlyFormComponent },

                                ]
                            },

                            {
                                path: 'professional-tax/professional-tax-form', component: ProfessionalTaxFormComponent,
                                // children: [
                                // {path : ':id/:mode', component: ProfessionalTaxFormComponent}
                                // ]
                            },

                            {
                                path: 'professional-tax/professional-tax-form/:id/:mode', component: ProfessionalTaxFormComponent,

                            },

                            {
                                path: 'emp-salary-details', component: EmpSalaryDetailsComponent,
                                children: [
                                    {

                                        path: '', component: EmpBasicDetailsGridComponent,
                                        children:
                                            [
                                                { path: ':id/fixed-allowances', component: FixedAllowanceGridComponent },
                                                { path: 'fixed-allowances', component: FixedAllowanceGridComponent },
                                                { path: 'fixed-allowances/fixed-allowances-form', component: FixedAllowanceFormComponent },
                                                { path: 'variable-allowances', component: VariableAllowanceGridComponent },
                                                { path: 'variable-allowances/variable-allowances-form', component: VariableAllowanceFormComponent },
                                                { path: 'fixed-deductions', component: FixedDeductionGridComponent },
                                                { path: 'variable-deductions', component: VariableDeductionGridComponent },
                                                { path: 'variable-deductions/variable-deductions-form', component: VariableDeductionFormComponent },
                                                { path: 'loan-details', component: LoanDetFormComponent },
                                            ]
                                    },

                                ]
                            },



                            { path: 'emp-salary-details/:id', component: EmpBasicDetailsGridComponent },

                            { path: 'emp-basic-details-form', component: EmpBasicDetailsFormComponent },
                            { path: 'emp-basic-details-form/:empId', component: EmpBasicDetailsFormComponent },

                            {
                                path: 'payroll-process-details', component: PayrollProcessDetailsMenuComponent,
                                children: [
                                    { path: '', component: PayrollPaymonthComponent },
                                    { path: 'payroll-attendace-leave', component: PayrollAttendaceLeaveComponent },
                                    { path: 'payroll-attendace-leave/:monthcode', component: PayrollAttendaceLeaveComponent },
                                    { path: 'payroll-process-payroll', component: PayrollProcessPayrollComponent },
                                    { path: 'payroll-process-payroll/:monthcode', component: PayrollProcessPayrollComponent },
                                    { path: 'payroll-finalize-payroll', component: PayrollFinalizePayrollComponent },
                                    { path: 'payroll-finalize-payroll/:monthcode', component: PayrollFinalizePayrollComponent },
                                ]
                            },
                            {
                                path: 'payroll-reports', component: PayrollReportsMenuComponent,
                                children: [
                                    { path: '', component: MasterReportsComponent },
                                    { path: 'summary-payroll-report', component: SummaryReportsComponent },
                                    { path: 'miscellaneous-payroll-reports', component: MiscellaneousReportsComponent },
                                ]
                            },

                            { path: 'variable-allowance-deduction', component: VariableAllowdeductionComponent },
                            { path: 'incometax', component: IncometaxParameterComponent },
                            { path: 'payrollprocess', component: PayrollProcessComponent },
                            { path: 'payrollfinalize', component: PayrollFinalizeComponent },
                            { path: 'payroll-authorize', component: PayrollAuthorizeGridComponent },
                            { path: 'payroll-authorize/payroll-authorize-form', component: PayrollAuthorizeFormComponent },
                            { path: 'payroll-sanction', component: PayrollSanctionGridComponent },
                            { path: 'payroll-sanction/payroll-sanction-form', component: PayrollSanctionFormComponent },
                            { path: 'allowances', component: AllowancesDetailsGridComponent },
                            { path: 'allowance-form', component: AllowancesDetailsFormComponent },
                            { path: 'monthly-attendance', component: MonthlyAttDetComponent },
                            { path: 'attendance', component: AttendanceDetailsGridComponent },
                            { path: 'attendance/attendance-form', component: AttendanceDetailsFormComponent },
                            { path: 'deduction', component: DeductionDetailsGridComponent },
                            { path: 'deduction-form', component: DeductionDetailsFormComponent },
                            { path: 'insurance', component: InsuranceDetailsGridComponent },
                            { path: 'insurance-form', component: InsuranceDetailsFormComponent },

                        ]
                    }
                ]
            },

            //sarita froms
            {
                path: 'transfer', component: HrmsComponent,
                children: [
                    {
                        path: '', component: TransferComponent,
                        children: [
                            { path: 'transferin', component: TransferInGridComponent },
                            { path: 'transferin-form', component: TransferInFormComponent },
                            { path: 'transferin-form/:transfer_id/:mode', component: TransferInFormComponent },
                            { path: '', component: TransferOutGridComponent },
                            { path: 'transferout-form', component: TransferOutFormComponent },
                            { path: 'transferout-form/:transfer_id/:mode', component: TransferOutFormComponent },
                            { path: 'transfer-authorization', component: TransferAuthorizationGridComponent },
                            { path: 'transfer-authorization/transfer-authorization-form', component: TransferAuthorizationFormComponent },
                            { path: 'transfer-sanction', component: TransferSanctionGridComponent },
                            { path: 'transfer-sanction/transfer-sanction-form', component: TransferSanctionFormComponent },
                            { path: 'transfer-rec', component: TransferRecordersGridComponent },
                            { path: 'transfer-rec-form', component: TransferRecordersFormComponent },
                        ]
                    }
                ]
            },
            {
                path: 'deputation', component: HrmsComponent,
                children: [
                    {
                        path: '', component: DeputaionComponent,
                        children: [
                            { path: '', component: DeputationOutGridComponent },
                            { path: 'deputationout-form', component: DeputationOutFormComponent },
                            { path: 'deputationin', component: DeputationInGridComponent },
                            { path: 'deputationin-form', component: DeputationInFormComponent },
                            { path: 'deputation-authorization', component: DeputationAuthorizationComponent },
                            { path: 'deputation-authorization/deputation-authorization-form', component: DeputationAuthorizationFormComponent },


                            { path: 'deputation-sanction', component: DeputaionSanctionGridComponent },
                            { path: 'deputation-sanction/deputation-sanction-form', component: DeputaionSanctionFormComponent },

                            { path: 'deputation-rec', component: DeputationRecGridComponent },
                            { path: 'deputation-rec/deputation-rec-form', component: DeputationRecFormComponent },

                            { path: 'deputationout-form/:DEPUTATION_ID/:mode', component: DeputationOutFormComponent },

                            { path: 'deputationin-form/:DEPUTATION_ID/:mode', component: DeputationInFormComponent },


                        ]
                    },
                ]
            },


            {
                path: 'emp-claims', component: HrmsComponent,
                children: [
                    {
                        path: '', component: EmployeeClaimsComponent,
                        children: [
                            { path: '', component: MedicalReimburesmentGridComponent },
                            { path: 'medical-reimburesment-form', component: MedicalReimburesmentComponent },
                            { path: 'medical-reimburesment-form/:MEDI_CLAIM_ID/:mode', component: MedicalReimburesmentComponent },

                            { path: 'medical-reim-sanction', component: MedReimSanctionGridComponent },
                            { path: 'medical-reim-sanction/medical-reim-sanction-form', component: MedReimSanctionFormComponent },

                            { path: 'htc-ltc', component: HtcLtcGridComponent },
                            { path: 'htc-ltc/htc-ltc-form', component: HtcLtcFormComponent },
                            { path: 'htc-ltc/htc-ltc-form/:LVCONS_ID/:mode', component: HtcLtcFormComponent },
                            { path: 'htc-ltc-sanction', component: HtcLtcSanctionGridComponent },
                            { path: 'htc-ltc-sanction/htc-ltc-sanction-form', component: HtcLtcSanctionFormComponent },

                            { path: 'htc-ltc-rec', component: HtcLtcRecGridComponent },
                            { path: 'htc-ltc-rec/htc-ltc-rec-form', component: HtcLtcRecFormComponent },


                            { path: 'leave-encashment', component: LeaveencashmentGridComponent },
                            { path: 'leave-encashment/leave-encashment-form', component: LeaveencashmentComponent },
                            { path: 'leave-encashment/leave-encashment-form/:LVENCASH_ID/:mode', component: LeaveencashmentComponent },

                            { path: 'medical-reimbursment-records', component: MedicalReimbursmentRecordsGridComponent },
                            { path: 'medical-reimbursment-records/medical-reimbursment-records-form', component: MedicalReimbursmentRecordsFormComponent },
                            { path: 'medical-reimbursment-records/medical-reimbursment-records-form/:MEDI_CLAIM_ID/:mode', component: MedicalReimbursmentRecordsFormComponent },

                            { path: 'medical-reim-authorization', component: MedReimAuthorizationComponent },
                            { path: 'htc-ltc-authorization', component: HtcLtcAuthComponent },
                            { path: 'leave-encash-authorization', component: LeaveEncashAuthComponent },
                            { path: 'leave-encash-sanction', component: LeaveEncashSanctionGridComponent },
                            { path: 'leave-encash-sanction-form', component: LeaveEncashSanctionFormComponent },

                            { path: 'leave-encashment-rec', component: LeaveEncashmentRecGridComponent },
                            { path: 'leave-encashment-rec/leave-encashment-rec-form', component: LeaveEncashmentRecFormComponent },

                        ]
                    },
                ]
            },
            // delete

            {
                path: 'training', component: HrmsComponent,
                children: [
                    {
                        path: '', component: TrainingComponent,
                        children: [
                            { path: '', component: TrainingDetailsGridComponent },
                            { path: 'training-form', component: TrainingDetailsFormComponent },
                            { path: 'training-approval', component: TrainingApprovalGridComponent },
                            { path: 'training-approval/training-approval-form', component: TrainingApprovalFormComponent },
                            { path: 'training-sanction', component: TrainingSanctionGridComponent },
                            { path: 'training-sanction/training-sanction-form', component: TrainingSanctionFormComponent },

                            { path: 'training-form/:TRAINING_ID/:mode', component: TrainingDetailsFormComponent },
                            { path: 'training-approval-form', component: TrainingApprovalFormComponent },
                            { path: 'training-record', component: TrainingRecordGridComponent },

                        ]
                    },

                ]
            },



            {
                path: 'deptexam', component: HrmsComponent,
                children: [
                    {
                        path: '', component: DepartmentalExamComponent,
                        children: [
                            { path: '', component: DepartmentalExamDetailsGridComponent },
                            { path: 'deptexam-form', component: DepartmentalExamDetailsFormComponent },
                            { path: 'deptexam-form/:EXAMINATION_ID/:mode', component: DepartmentalExamDetailsFormComponent },
                            { path: 'dept-exam-authorization', component: DeptExamAuthComponent },
                            { path: 'dept-exam-authorization/dept-exam-authorization-form', component: DeptExamAuthFormComponent },
                            { path: 'dept-exam-sanction', component: DeptExamSanctionGridComponent },
                            { path: 'dept-exam-sanction/dept-exam-sanction-form', component: DeptExamSanctionFormComponent },

                            { path: 'dept-exam-record', component: DeptExamRecordGridComponent },
                            { path: 'dept-exam-record/dept-exam-record-form', component: DeptExamRecordFromComponent },
                        ]
                    },

                ]
            },
            {
                path: 'nominationapp', component: HrmsComponent,
                children: [
                    {
                        path: '', component: NominationComponent,
                        children: [
                            { path: '', component: NominationApplicationGridComponent },
                            { path: 'nominationapp-form', component: NominationApplicationComponent },
                            { path: 'nominationapp-form/:NMNT_ID/:mode', component: NominationApplicationComponent },

                            { path: 'nomination-approval', component: NominationApprovalGridComponent },
                            { path: 'nomination-approval/nomination-approval-form', component: NominationApprovalFormComponent },


                            { path: 'nomination-san', component: NominationSanGridComponent },
                            { path: 'nomination-record', component: NominationRecGridComponent },


                        ]
                    },

                ]
            },



            {
                path: 'dept-enquiry', component: HrmsComponent,
                children: [
                    {
                        path: '', component: DepartEnquiryMenuComponent,
                        children: [
                            { path: '', component: ComplaintsRegGridComponent },
                            { path: 'complaints-reg-form/:back', component: ComplaintsRegFormComponent },
                            { path: 'complaints-reg-form/:COMPLAINT_ID/:back/:mode', component: ComplaintsRegFormComponent },

                            { path: 'show-cause', component: ShowCaseGridComponent },
                            { path: 'show-cause-form', component: ShowCaseFormComponent },
                            { path: 'show-cause-form/:COMPLAINT_ID/:SCN_ID/:back/:mode', component: ShowCaseFormComponent },


                            { path: 'show-cause-ack', component: ShowCauseAckGridComponent },
                            { path: 'show-cause-ack-form', component: ShowCauseAckFormComponent },
                            { path: 'show-cause-ack-form/:COMPLAINT_ID/:SCN_ID/:back/:mode', component: ShowCauseAckFormComponent },

                            { path: 'enquiry-proceeding', component: EnquiryProceedingGridComponent },
                            { path: 'enquiry-proceeding-form', component: EnquiryProceedingFormComponent },
                            { path: 'enquiry-proceeding-form/:ENQUIRY_ID/:PROCEEDING_ID/:mode', component: EnquiryProceedingFormComponent },

                            { path: 'initiative-depart', component: InitiateDepartEnquiryGridComponent },
                            { path: 'initiative-depart-form/:back', component: InitiateDepartEnquiryFormComponent },
                            { path: 'initiative-depart-form/:ENQUIRY_ID/:back/:mode', component: InitiateDepartEnquiryFormComponent },


                            { path: 'complaint-reg-auth', component: ComplaintRegAuthComponent },
                            { path: 'complaint-reg-auth/complaint-reg-auth-form', component: ComplaintRegAuthFormComponent },
                            { path: 'complaint-reg-auth/complaint-reg-auth-form/:COMPLAINT_ID/:mode', component: ComplaintRegAuthFormComponent },


                            { path: 'scn-auth', component: ScnAuthorizationComponent },
                            { path: 'scn-auth/scn-auth-form', component: ScnAuthorizationFormComponent },
                            // { path: 'scn-auth/scn-auth-form', component: ScnAuthorizationFormComponent }, 
                            { path: 'scn-auth/scn-auth-form/:SCN_ID/:mode', component: ScnAuthorizationFormComponent },



                            { path: 'scn-remainer', component: ScnRemainderComponent },
                            { path: 'scn-remainer/scn-remainer-form', component: ScnRemainderFormComponent },
                            { path: 'scn-remainer/scn-remainer-form/:SCN_ID/:mode', component: ScnRemainderFormComponent },

                            { path: 'enquiry-closure', component: EnquiryCloserGridComponent },
                            { path: 'enquiry-closure-form', component: EnquiryCloserFormComponent },
                            { path: 'enquiry-closure-form/:ENQUIRY_ID/:mode', component: EnquiryCloserFormComponent },

                            { path: 'external-enquiry-form', component: ExternalEnquiryFormComponent },
                            { path: 'external-enquiry-form/:EEN_ID/:mode', component: ExternalEnquiryFormComponent },
                            { path: 'external-enquiry-grid', component: ExternalEnquiryGridComponent },
                            { path: 'ex-enquiry-closure-grid', component: ExternalEnquiryClosureGridComponent },
                            { path: 'ex-enquiry-closure-form', component: ExternalEnquiryClosureFormComponent },

                            { path: 'ex-enquiry-closure-form/:EEN_ID/:mode', component: ExternalEnquiryClosureFormComponent }


                        ]
                    },


                ]
            },





            {
                path: 'leaveapp', component: HrmsComponent,
                children: [
                    {
                        path: '', component: AttendanceLeavesComponent,
                        children: [
                            { path: '', component: DailyAttendanceGridComponent },
                            { path: 'daily-attendance', component: DailyAttendanceFormComponent },
                            { path: 'daily-attendance/:id/:mode', component: DailyAttendanceFormComponent },
                            { path: 'daily-attendance-out', component: DailyAttendanceOutGridComponent },
                            { path: 'daily-attendance-out-form/:id/:mode', component: DailyAttendanceOutFormComponent },
                            { path: 'daily-attendance-out-form', component: DailyAttendanceOutFormComponent },
                            { path: 'leave-application', component: LeaveTypeGridComponent },
                            { path: 'leaveapp-form', component: LeaveTypeComponent },
                            { path: 'leaveapp-form/:id/:mode', component: LeaveTypeComponent },
                            { path: 'leave-authorization', component: LeaveAuthGridComponent },
                            { path: 'leave-authorization/leave-authorization-form', component: LeaveAuthFormComponent },
                            { path: 'leave-authorization/leave-authorization-form/:id/:mode', component: LeaveAuthFormComponent },
                            { path: 'leave-sanction', component: LeaveSanctionGridComponent },
                            { path: 'monthly-leave-atten', component: MonthlyLeaveAttenGridComponent },
                            { path: 'leave-sanction/leave-sanction-form', component: LeaveSanctionFormComponent },
                            { path: 'time-roll-gen', component: TimeRollGenGridComponent },
                            //{ path: 'time-roll-gen/:Id', component: TimeRollGenGridComponent },                            
                            { path: 'time-roll-gen-form', component: TimeRollGenFormComponent },
                            { path: 'time-roll-gen-form/:Id/:mode', component: TimeRollGenFormComponent },

                            { path: 'time-roll-approval', component: TimeRollApprveGridComponent },
                            { path: 'time-roll-approval-form', component: TimeRollApprveFormComponent },
                            { path: 'time-roll-sanction', component: TimeRollSanGridComponent },
                            { path: 'time-roll-sanction-form', component: TimeRollSanFormComponent },

                            { path: 'time-roll-fin', component: TimeRollFinGridComponent },
                            { path: 'time-roll-fin-form', component: TimeRollFinFormComponent },
                            { path: 'time-roll-uninti', component: TimeRollUnintiGridComponent },
                            { path: 'time-roll-uninti-form', component: TimeRollUnintiFormComponent }

                        ]
                    },
                ]
            },
            // {
            //     path: 'deptexam', component: HrmsComponent,
            //     children: [
            //         {
            //             path: '', component: DepartmentalExamComponent,
            //             children: [
            //                 { path: '', component: DepartmentalExamDetailsGridComponent },
            //                 { path: 'deptexam-form', component: DepartmentalExamDetailsFormComponent },
            //                 { path: 'deptexam-form/:EXAMINATION_ID/:mode', component: DepartmentalExamDetailsFormComponent },
            //                 { path: 'dept-exam-authorization', component: DeptExamAuthComponent },
            //                 { path: 'dept-exam-authorization/dept-exam-authorization-form', component: DeptExamAuthFormComponent },
            //                 { path: 'dept-exam-sanction', component: DeptExamSanctionGridComponent },
            //                 { path: 'dept-exam-sanction/dept-exam-sanction-form', component: DeptExamSanctionFormComponent },



            //             ]
            //         },

            //     ]
            // },
            // {
            //     path: 'nominationapp', component: HrmsComponent,
            //     children: [
            //         {
            //             path: '', component: NominationComponent,
            //             children: [
            //                 { path: '', component: NominationApplicationGridComponent },
            //                 { path: 'nominationapp-form', component: NominationApplicationComponent },
            //                 { path: 'nominationapp-form/:NMNT_ID/:mode', component: NominationApplicationComponent },

            //                 { path: 'nomination-approval', component: NominationApprovalGridComponent },
            //                 { path: 'nomination-approval/nomination-approval-form', component: NominationApprovalFormComponent },
            //                 { path: 'nomination-sanction', component: NominationSanctionGridComponent },
            //                 { path: 'nomination-sanction/nomination-sanction-form', component: NominationSanctionFormComponent },

            //             ]
            //         },

            //     ]
            // },

            // {
            //     path: 'leavecredit', component: HrmsComponent,
            //     children: [
            //         {
            //             path: '', component: LeaveCreditComponent,
            //             children: [
            //                 { path: 'leavecredit-form', component: LeavecreditComponent },
            //                 { path: 'leavecredit-form/:Id/:mode', component: LeavecreditComponent },
            //                 { path: '', component: LeavecreditGridComponent },
            //                 { path: 'leave-credit-auth', component: LeaveCreditAuthComponent },
            //                 { path: 'leave-credit-auth/:id', component: LeaveCreditAuthComponent },
            //                 { path: 'leave-credit-auth/leave-credit-auth-form', component: LeaveCreditAuthFormComponent },
            //                 { path: 'leave-credit-sanction', component: LeaveCreditSanctionGridComponent },
            //                 { path: 'leave-credit-sanction/leave-credit-sanction-form', component: LeaveCreditSanctionFormComponent },
            //                 { path: 'leave-credit-bulk', component: LeaveCreditBulkComponent },
            //                 { path: 'leave-credit-bulk-form', component: LeaveCreditBulkFormComponent },
            //                 { path: 'leave-credit-bulk-form/:Id/:mode', component: LeaveCreditBulkFormComponent },
            //                 { path: 'bulk-leave-credit-approval', component : BulkLeaveCreditApprovalComponent },
            //                 { path: 'bulk-leave-credit-sanction', component : BulkLeaveCreditSanctionComponent },
            //             ]
            //         },

            //     ]
            // },
            {
                path: 'leavecredit', component: HrmsComponent,
                children: [
                    {
                        path: '', component: LeaveCreditComponent,
                        children: [
                            { path: 'leavecredit-form', component: LeavecreditComponent },
                            { path: 'leavecredit-form/:Id/:mode', component: LeavecreditComponent },
                            { path: '', component: LeavecreditGridComponent },
                            { path: 'leave-credit-auth', component: LeaveCreditAuthComponent },
                            { path: 'leave-credit-auth/:id', component: LeaveCreditAuthComponent },
                            { path: 'leave-credit-auth/leave-credit-auth-form', component: LeaveCreditAuthFormComponent },
                            { path: 'leave-credit-sanction', component: LeaveCreditSanctionGridComponent },
                            { path: 'leave-credit-sanction/leave-credit-sanction-form', component: LeaveCreditSanctionFormComponent },
                            { path: 'leave-credit-bulk', component: LeaveCreditBulkComponent },
                            { path: 'leave-credit-bulk-form', component: LeaveCreditBulkFormComponent },
                            { path: 'leave-credit-bulk-form/:Id/:mode', component: LeaveCreditBulkFormComponent },
                            { path: 'bulk-leave-credit-approval', component: BulkLeaveCreditApprovalComponent },
                            { path: 'bulk-leave-credit-sanction', component: BulkLeaveCreditSanctionComponent },
                        ]
                    },

                ]
            },
            {
                path: 'monthlyattendance', component: HrmsComponent,
                children: [
                    { path: 'monthlyattendance-form', component: MonthlyAttendanceComponent },
                    { path: '', component: MonthlyAttendanceGridComponent },
                ]
            },
            // {
            //     path: 'promotion', component: HrmsComponent,
            //     children: [
            //         {
            //             path: '', component: PromotionsComponent,
            //             children: [
            //                 { path: '', component: PromotionGridComponent },
            //                 { path: 'promotion-form', component: PromotionComponent },
            //                 { path: 'pro-auth-grid', component: PromotionAuthGridComponent },
            //                 { path: 'pro-auth-grid/pro-auth-form', component: PromotionAuthFormComponent },
            //                 { path: 'pro-sanction', component: PromotionsSanctionGridComponent },
            //                 { path: 'pro-sanction/pro-sanction-form', component: PromotionsSanctionFormComponent },
            //                 // { path: 'gen-pro-list', component: GenProListGridComponent },
            //                 // { path: 'gen-pro-list-form', component: GenProListComponent },
            //                 // { path: 'pro-list-auth', component: ProListAuthGridComponent }, 
            //                 // { path: 'pro-list-auth-form', component: ProListAuthComponent }, 
            //                 // { path: 'promotion-post', component: PromotionPostGridComponent }, 
            //                 // { path: 'promotion-post-form', component: PromotionPostFormComponent }, 
            //             ]
            //         },

            //     ]
            // },
            {
                path: 'promotion', component: HrmsComponent,
                children: [
                    {
                        path: '', component: PromotionsComponent,
                        children: [
                            { path: '', component: PromotionGridComponent },
                            { path: 'promotion-form', component: PromotionComponent },
                            { path: 'pro-auth-grid', component: PromotionAuthGridComponent },
                            { path: 'pro-auth-grid/pro-auth-form', component: PromotionAuthFormComponent },
                            { path: 'pro-sanction', component: PromotionsSanctionGridComponent },
                            { path: 'pro-sanction/pro-sanction-form', component: PromotionsSanctionFormComponent },
                            { path: 'promotion-form/:PROMOTION_LIST_ID/:mode', component: PromotionComponent },
                            { path: 'promotion-form/:PROMOTION_LIST_ID/:BackId/:mode', component: PromotionComponent },
                            // { path: 'gen-pro-list', component: GenProListGridComponent },
                            // { path: 'gen-pro-list-form', component: GenProListComponent },
                            // { path: 'pro-list-auth', component: ProListAuthGridComponent }, 
                            // { path: 'pro-list-auth-form', component: ProListAuthComponent }, 
                            // { path: 'promotion-post', component: PromotionPostGridComponent }, 
                            // { path: 'promotion-post-form', component: PromotionPostFormComponent }, 
                        ]
                    },

                ]
            },
            {
                path: 'increment', component: HrmsComponent,
                children: [
                    {
                        path: '', component: IncrementsComponent,
                        children: [
                            // { path: '', component: IncrementGridComponent },
                            // { path: 'increment-form', component: IncrementComponent},
                            { path: '', component: GenIncrListGridComponent },
                            { path: 'gen-incr-list-form', component: GenIncrListComponent },
                            { path: 'gen-incr-list-form/:id/:mode', component: GenIncrListComponent },
                            { path: 'incr-list-auth', component: IncrListAuthGridComponent },
                            { path: 'incr-list-auth-form', component: IncrListAuthComponent },
                            { path: 'incr-sanction', component: IncrementsSanctionGridComponent },
                            { path: 'incr-sanction/incr-sanction-form', component: IncrementsSanctionFormComponent },
                            { path: 'increment-post', component: IncrementPostingGridComponent },
                            { path: 'increment-post-form', component: IncrementPostingFormComponent },
                        ]
                    }]
            },
            {
                path: 'rti', component: HrmsComponent,
                children: [
                    { path: 'rti-form', component: RtiComponent },
                    { path: '', component: RtiGridComponent }
                ]
            },
            {
                path: 'empseparation', component: HrmsComponent,
                children: [
                    {
                        path: '', component: EmployeeSeparationComponent,
                        children: [
                            { path: '', component: EmpRetirementListComponent },
                            { path: 'emp-separations', component: EmpSeparationGridComponent },
                            { path: 'emp-separation-form', component: EmpSeparationComponent },
                            { path: 'emp-separation-form/:id', component: EmpSeparationComponent },
                            { path: 'emp-sep-authorization', component: EmpSepAuthComponent },
                            { path: 'emp-sep-authorization/emp-sep-authorization-form', component: EmpSepAuthFormComponent },
                        ]
                    },
                ]
            },
        ]

    },
    {
        path: 'login', component: RegistrationComponent,
        children: [{ path: '', component: LoginComponent }]
    },

    {
        path: 'signup', component: RegistrationComponent,
        children: [{ path: '', component: SignupComponent }]
    },

    {
        path: 'forgot-password', component: RegistrationComponent,
        children: [{ path: '', component: ForgotPasswordComponent }]
    },

    {
        path: 'provisionlist', component: ProvisionlistComponent
    },

    {
        path: 'provisionlist/:S_NotificationID/:S_ProjectID', component: ProvisionlistComponent
    },

    {
        path: 'finalList', component: FinalListComponent
    },

    {
        path: 'khbnotification/:NotificationID/:ProjectID/:CaTName', component: KhbnotificationComponent
    },
    {
        path: 'khbnotificationltr/:APP_Id/:PD_Id', component: KhbnotificationltrComponent
    },
    {
        path: 'khbnoticeletter/:AppId/:NotificationID/:ProjectID/:Type', component: NotieLetterComponent
    },
    {
        path: 'khborderletter/:AppId/:NotificationID/:ProjectID/:Type', component: OrderLetterComponent
    },
    {
        path: 'khb-challan/:AppNo/:Mode', component: khbChallanComponent
    },

    {
        path: 'khb-challan-insta/:AppNo/:AmtType', component: KhbInstachallanComponent
    },

    {
        path: 'auction-intimation/:AuctionId', component: auctionintimationComponent
    },

    {
        path: 'auction-notification/:AuctionId', component: auctionnotificationComponent
    },
    {
        path: 'Token-view/:LO_NO_Id_FK/:LO_PD_Id_FK/:LO_CA_Id_FK/:LO_RES_Id_FK/:LO_PT_Id_FK', component: ManualLotteryTokenComponent
    },

    {
        path: 'bundleReports', component: BundleReportsComponent
    },

    {
        path: 'SubbAppReports', component: SubmittedAppReportsComponent,

    },

    {
        path: 'RequestAppReports', component: RequestAppRecordsComponent,

    },

    {
        path: 'allotedPropertyList', component: AllotedPropertyListComponent,

    },

    {
        path: 'cancellationList', component: CancellationReportsComponent,

    },

    {
        path: 'allocatedList', component: PrAllocatedPropListComponent,

    },
    //PrVacantPropListComponent

    {
        path: 'vacantList', component: PrVacantPropListComponent,

    },


    {
        path: 'apply-allotment', component: UserApplicationComponent,
        children: [
            { path: '', component: ApplicantApplicationComponent },
            { path: 'apply-application-form/:NO_Id/:PD_Id', component: ApplicantApplicationFormComponent }
        ]
    },

    { path: '', redirectTo: '/login', pathMatch: 'full' }
];




// WEBPACK FOOTER //
// ./src/route.ts